const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User created successfully! Log in now!!!",
          fail: "Error creating user. Please check the provided information.",
          userCreationDisabled: "New user registration is disabled.",
          verificationError: "Error verifying registration permissions.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          company: "Organization Name",
          phone: "WhatsApp (Country code + number)",
          phonePlaceholder: "+1 (000) 000-0000",
          plan: "Plan",
          planDetails: {
            attendants: "Agents",
            whatsapp: "WhatsApp",
            queues: "Queues",
            currency: "$",
          },
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      validation: {
        tooShort: "Too short!",
        tooLong: "Too long!",
        required: "Required",
        invalidEmail: "Invalid email",
      },
      schedulesForm: {
        keepFlowsOutOfHours: {
          title: "Keep flows active outside business hours",
          description: "When ON, chatbots and FlowBuilder flows keep responding even outside business hours. The out-of-hours message below is not sent in this mode.",
        },
        outOfHoursMessage: {
          title: "Out-of-hours message",
          description: "Sent automatically when a customer messages outside business hours.",
          placeholder: "Ex.: Hi! We're out of business hours. We'll get back to you soon.",
        },
        helps: {
          keepFlowsOutOfHours: {
            description: "Controls what happens when someone messages outside the schedule configured below.",
            steps: [
              "OFF (default): bots and flows are paused; the customer receives the out-of-hours message (if configured).",
              "ON: bots and FlowBuilder keep running normally; no out-of-hours message is sent.",
              "Turn ON when your flows handle 24/7 (self-service, FAQ, AI).",
              "Keep OFF if your flow includes human agents that go offline.",
            ],
          },
          outOfHoursMessage: {
            description: "Text sent once per ticket when a customer writes outside business hours.",
            steps: [
              "Turn the toggle ON and type the message that will be sent automatically.",
              "Sent only once per ticket — the customer is not spammed if they send multiple messages.",
              "Works together with the schedule set in \"General › Working Hours Schedule\".",
              "Not sent if \"Keep flows active outside business hours\" is ON.",
            ],
          },
        },
        bulk: {
          fillWeekdays: "Weekdays 9 AM – 6 PM",
          fillWeekdaysHelp: "Fills Monday–Friday with 09:00–12:00 and 13:00–18:00",
          closeWeekend: "Close weekend",
          closeWeekendHelp: "Clears Saturday and Sunday",
          copyFirst: "Copy from first day",
          copyFirstHelp: "Applies Monday's hours to all other days",
          clearAll: "Clear all",
          clearAllHelp: "Removes all configured hours",
        },
        morning: "Morning",
        afternoon: "Afternoon",
        start: "Start",
        end: "End",
        dayClosed: "Closed on this day",
      },
      login: {
        title: "Login",
        logoAlt: "Logo",
        emailLabel: "Email",
        passwordLabel: "Password",
        rememberMe: "Remember me",
        loginButton: "Log In",
        signupButton: "Sign up",
        noAccount: "Don't have an account?",
        forgotPassword: "Forgot password?",
        secureArea: "Secure area",
        emailPlaceholder: "you@example.com",
        togglePassword: "Toggle password visibility",
        or: "or",
        whatsappLabel: "Chat with us on WhatsApp",
        whatsappTitle: "Chat with us on WhatsApp",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Log In",
          register: "Don't have an account? Sign up!",
        },
      },
      companies: {
        title: "Companies",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company created successfully!",
        },
      },
      auth: {
        toasts: {
          success: "Login successful!",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
        },
        token: "Token",
      },
      forgotPassword: {
        title: "Reset Password",
        form: {
          emailLabel: "Enter your email",
          submitButton: "Send Reset Link",
          backToLogin: "Back to Login",
        },
        loading: {
          sending: "Sending...",
          sent: "Sent!",
        },
        toasts: {
          success: "Password reset link sent successfully",
        },
      },
      resetPassword: {
        title: "Reset Password",
        form: {
          newPassword: "New Password",
          confirmPassword: "Confirm Password",
        },
        buttons: {
          submit: "Reset Password",
          submitting: "Resetting...",
          submitted: "Reset!",
          backToLogin: "Back to Login",
        },
        errors: {
          passwordMismatch: "Passwords do not match",
          passwordTooShort: "Password must be at least 6 characters long",
          invalidToken: "Reset token is missing or invalid. Please request a new reset link.",
          resetError: "Error resetting password. Please try again.",
        },
        toasts: {
          success: "Password reset successfully",
          passwordMismatch: "Passwords do not match",
          passwordTooShort: "Password must be at least 6 characters long",
        },
      },
      financeiro: {
        title: "Billing",
        subtitle: "Track the status of companies, plans and invoices in one place.",
        table: {
          details: "Details",
          users: "Users",
          connections: "Connections",
          queues: "Queues",
          value: "Monthly value",
          dueDate: "Due Date",
          status: "Status",
          action: "Action",
          company: "Company",
          plan: "Plan"
        },
        stats: {
          total: "Companies",
          totalHint: "Registered in the system",
          revenue: "Active revenue",
          revenueHint: "Estimated monthly recurrence",
          overdue: "Overdue",
          overdueHint: "Pending payments",
          trial: "On trial",
          trialHint: "No payment yet"
        },
        filters: {
          search: "Search by name or email...",
          status: "Status",
          all: "All statuses"
        },
        statusList: {
          active: "Active",
          overdue: "Overdue",
          trial: "Trial",
          pending: "Pending",
          inactive: "Inactive"
        },
        empty: {
          list: "No companies registered yet.",
          filtered: "No companies match your filters."
        },
        tooltips: {
          details: "Invoice details",
          users: "Number of users",
          connections: "Number of connections",
          queues: "Number of queues",
          value: "Invoice value",
          dueDate: "Due date"
        },
        status: {
          paid: "Paid",
          overdue: "Overdue",
          open: "Open",
          yes: "Yes",
          no: "No",
          overdueFor: "Overdue for {{days}} days",
          dueToday: "Due today",
          dueIn: "Due in {{days}} days"
        },
        buttons: {
          pay: "PAY",
          paid: "PAID",
          payNow: "PAY NOW",
          charge: "Charge",
          chargeClient: "Charge customer",
          inactive: "Inactive"
        },
        charge: {
          title: "Charge customer",
          phone: "Phone",
          email: "Email",
          messageLabel: "Message",
          whatsapp: "Send via WhatsApp",
          emailBtn: "Send email",
          emailSubject: "Outstanding balance",
          openLink: "Open invoice link",
          copy: "Copy message",
          copied: "Message copied!",
          copyError: "Couldn't copy.",
          noPhone: "Company has no phone on file.",
          noEmail: "Company has no email on file.",
          noLink: "Invoice has no payment link."
        },
        checkout: {
          title: "Almost there!",
          steps: {
            data: "Data",
            customize: "Customize",
            review: "Review"
          },
          messages: {
            notFound: "Not Found",
            paymentNotice: "After making the payment, refresh the page!",
            subscriptionSuccess: "Subscription completed successfully! Awaiting payment processing"
          },
          buttons: {
            back: "BACK",
            pay: "PAY",
            next: "NEXT"
          },
          pricing: {
            users: "Users",
            connection: "Connection",
            queues: "Queues",
            select: "SELECT",
            perMonth: "/month"
          },
          review: {
            title: "Subscription summary"
          },
          success: {
            total: "TOTAL",
            copied: "Copied",
            copyQr: "Copy QR code",
            finalizeMessage: "To complete, just make the payment by scanning or pasting the Pix code above :)",
            licenseRenewed: "Your license has been renewed until"
          },
          planDetails: {
            title: "Plan details",
            billing: "Billing: Monthly"
          },
          paymentInfo: {
            title: "Payment information",
            email: "Email:",
            name: "Name:",
            document: "CPF/CNPJ:",
            total: "Total:"
          }
        }
      },
      dashboard: {
        title: "Dashboard",
        subtitle: "Real-time overview of your support operation",
        buttons: {
          filter: "Filter",
          export: "Export"
        },
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
          performance: "Performances"
        },
        charts: {
          performance: "Charts",
          userPerformance: "Users Chart",
          hourlyServices: "Services per hour",
          ticketsLabel: "Tickets",
          score: "Score",
          perDay: {
            title: "Services today: ",
          },
          errorFetchingTickets: "Error fetching ticket information",
          noDataAvailable: "No data available for the selected period.",
          avgPerDay: "Avg/day",
          peak: "Peak",
          totalAgents: "Agents",
          topAgent: "Top performer",
          day: "day",
          days: "days",
          presets: {
            today: "Today",
            month: "Month"
          },
        },
        cards: {
          inAttendance: "In Service",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Completed",
          newContacts: "New Contacts",
          totalReceivedMessages: "Messages Received",
          totalSentMessages: "Messages Sent",
          averageServiceTime: "Avg. Service Time",
          averageWaitingTime: "Avg. Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Services",
          statusNow: "Current",
          totalCallsUser: "Total services per user",
          totalAttendances: "Total services",
          totalLabel: "Total attendances: {{count}}",
          queues: "Queues",
          defaultQueue: "Default Connection",
          workingHours: "Working Hours",
          startWork: "Start Work",
          endWork: "End Work",
          farewellMessage: "Farewell Message",
          theme: "Default Theme",
          menu: "Default Menu",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Services",
          callsWaitRating: "Services awaiting rating",
          callsWithoutRating: "Services without rating",
          ratedCalls: "Rated Services",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
          generalScore: "Overall NPS Score",
        },
        status: {
          online: "Online",
          offline: "Offline",
        },
        filters: {
          title: "Filters",
          initialDate: "Initial",
          finalDate: "Final",
          filterButton: "Filter",
        },
        errors: {
          loadData: "Failed to load dashboard data.",
          exportExcel: "Error exporting to Excel.",
        },
        export: {
          sheetName: "AgentReport",
          fileName: "agent-report.xlsx",
        },
        nps: {
          overallScore: "Overall NPS Score",
        },
      },
      reports: {
        title: "Survey Reports",
        subtitle: "Complete history of services with filters and export",
        kpis: {
          total: "Total tickets",
          open: "Open",
          closed: "Closed",
          rated: "Rated",
        },
        table: {
          id: "ID",
          whatsapp: "Connection",
          contact: "Contact",
          user: "Agent",
          queue: "Queue",
          status: "Status",
          lastMessage: "Last message",
          dateOpen: "Opened at",
          dateClose: "Closed at",
          supportTime: "Service time",
          NPS: "NPS",
          actions: "Actions",
          empty: "No services found for the applied filters.",
        },
        buttons: {
          filter: "Filter",
          onlyRated: "Only rated",
          export: "Export",
          clear: "Clear filters",
        },
        filters: "Filters",
        contactSearch: "Search contact...",
        contactSearchHint: "Type at least 2 characters",
        operator: "Operator",
        period: "Period",
        until: "Until",
        date: "Date",
        reportTitle: "Reports",
        calls: "Services",
        search: "Surveys",
        durationCalls: "Service Duration",
        grupoSessions: "Group Services",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generating compressed report, please wait.",
          errorToast: "Error generating report",
          back: "Back",
          groupServiceReport: "Group Service Report",
          loading: "Loading...",
          contact: "Contact",
          dateOpen: "Opening Date",
          dateLastUpdated: "Last Updated Date",
          agent: "Who Attended",
          agentClosed: "Who Closed",
          waitingAssistance: "Awaiting Assistance",
          process: "In Service",
        },
        researchReports: {
          response: "response",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantity",
          percentage: "percentage",
          title: "Survey Reports",
          activeSearch: "Active Survey",
          inactiveSearch: "Inactive Survey",
        },
        ticketDurationDetail: {
          msgToast: "Generating compressed report, please wait.",
          title: "Service Duration Report",
          startService: "Service Start",
          lastUpdated: "Last Updated",
          lastAgent: "Last Agent",
          durationFinished: "Duration After Completion",
        },
        ticketDuration: {
          title: "Service Duration Report",
          contact: "Contact",
          open: "Open",
          pending: "Pending",
          finished: "Completed",
          durationFinished: "Completed Duration",
          durationAfterFinished: "Duration After Completion",
          actions: "Actions",
        },
        ticketReports: {
          msgToast: "Generating compressed report, please wait.",
          title: "Service Report",
        },
        pdf: {
          title: "List of Completed Services",
          exportTitle: "List of Completed Group Services",
        },
        form: {
          initialDate: "Initial Date",
          finalDate: "Final Date",
        },
        excel: {
          connection: "Connection",
          contact: "Contact",
          user: "User",
          queue: "Queue",
          status: "Status",
          lastMessage: "LastMessage",
          dateOpen: "OpenDate",
          timeOpen: "OpenTime",
          dateClose: "CloseDate",
          timeClose: "CloseTime",
          supportTime: "SupportTime",
          nps: "nps",
          fileName: "service-report.xlsx",
          sheetName: "ServiceReport",
        },
        tooltips: {
          ticketLogs: "Ticket Logs",
          accessTicket: "Access Ticket",
          exportExcel: "Export to Excel",
        },
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        save: "Save",
        task: "Tasks",
      },
      contactImportWpModal: {
        modalTitle: "Export / Import Contacts",
        title: "Export Contacts to Excel",
        buttons: {
          downloadModel: "Download Excel template for import",
          closed: "Close",
          import: "Select the Excel file to import Contacts",
        },
        form: {
          connection: "WhatsApp Connection",
          connectionPlaceholder: "Select connection...",
          importType: "Import type",
          importAll: "Import all contacts",
          importSelected: "Import selected contacts",
          overwriteExisting: "Overwrite existing contacts"
        },
        validation: {
          connectionRequired: "You must select a connection",
          noContactsFound: "No contacts found to import"
        },
        progress: {
          importing: "Importing contacts...",
          imported: "Contacts imported: {count}",
          duplicated: "Duplicate contacts: {count}",
          failed: "Failed contacts: {count}"
        },
        sheetName: "Contacts",
        columns: {
          name: "Name",
          number: "Number",
          email: "E-mail",
          tags: "Tags",
          followUp: "Follow Up",
          productName: "Product (Name)",
          productStatus: "Product (Status)",
        },
        sampleContact: {
          name: "John",
          number: "15551234567",
          email: "john@email.com",
          tags: "customer, vip",
          followUp: "",
          productName: "Marketing Course",
          productStatus: "completed",
        },
      },
      tagsContainer: {
        title: "Contact Tags",
        placeholder: "Add tag...",
        add: "Add",
        remove: "Remove",
        noTags: "No tags assigned",
        createNew: "Create new tag",
        searchPlaceholder: "Search tags...",
        buttons: {
          save: "Save Tags",
          cancel: "Cancel",
          clear: "Clear All"
        },
        validation: {
          tagRequired: "Tag name is required",
          tagExists: "This tag already exists",
          maxTags: "Maximum {max} tags allowed"
        }
      },
      allConnections: {
        errors: {
          loadCompanies: "Could not load the list of records",
          unknownChannel: "error"
        },
        subtitle: "Connect your service channels to receive messages and start conversations with your customers.",
        channels: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram"
        },
        table: {
          client: "Client",
          connectedConnections: "Connected Connections",
          disconnectedConnections: "Disconnected Connections",
          totalConnections: "Total Connections",
          total: "Total"
        }
      },
      companyWhatsapps: {
        title: "Connections of: {{companyName}}",
        table: {
          channel: "Channel"
        }
      },
      channels: {
        whatsapp: "WhatsApp",
        whatsappOfficial: "WhatsApp Official API",
        facebook: "Facebook",
        instagram: "Instagram"
      },
      connections: {
        title: "Connections",
        subtitle: "Manage your service channels (WhatsApp, Facebook, Instagram)",
        waitConnection: "Wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        toasts: {
          deleted: "Connection deleted successfully!",
          officialApiSoon: "Official API integration coming soon!",
          closedimported:
            "We are closing the imported tickets, please wait a moment",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage:
            "If you confirm, all imported tickets will be closed",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure? You will need to scan the QR code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "NEW QR CODE",
          closedImported: "Close all Imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
          edit: "Edit",
          delete: "Delete",
        },
        empty: "No connections registered.",
        status: {
          connected: "Connected",
          disconnected: "Disconnected",
          syncError: "Sync failure",
          qrcode: "QR Code",
          pairing: "Pairing",
          timeout: "Timeout",
          comingSoon: "Coming soon",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message date",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Ensure your phone is connected to the internet and try again, or request a new QR code",
          },
          qrcode: {
            title: "Waiting for QR code scan",
            content:
              "Click the 'QR CODE' button and scan the QR code with your phone to start the session",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection to the phone was lost",
            content:
              "Ensure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR code",
          },
          syncError: {
            title: "Failed to process messages",
            content:
              "The session is connected, but the system failed to persist connection data. Restart the connection and check again.",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "WhatsApp Number",
          channel: "Channel",
        },
        iconChannel: {
          error: "Error",
        },
        facebook: {
          success: "Page connected successfully!",
        },
      },
      facebookModal: {
        title: "Connect {{channel}}",
        description: "Follow the steps below to connect {{channel}} to the support system.",
        steps: {
          step1: {
            title: "Have an App configured on Meta for Developers",
            description: "You need to have an application created on Meta for Developers with Messenger and Instagram products configured.",
          },
          step2: {
            title: "Have a Facebook Page",
            description: "You need to be an administrator of a Facebook Page. Messenger will be connected to this page.",
          },
          step3instagram: {
            title: "Instagram Business account linked to the Page",
            description: "To receive Instagram messages, your Instagram account needs to be Business or Professional type and linked to your Facebook Page.",
          },
          stepConnect: {
            title: "Authorize the connection",
            description: "Click the button below to log in with your Facebook account and authorize {{channel}} to receive and send messages through the system.",
          },
        },
        permissions: {
          title: "Requested permissions:",
          sendReceive: "Send and receive messages through the page",
          pagesList: "List your Facebook pages",
          managePages: "Manage page metadata",
          instagramMessages: "Send and receive Instagram Direct messages",
        },
        warning: {
          title: "Important:",
          facebook: "After authorization, all pages linked to your account will be connected automatically.",
          instagram: "Your Instagram account needs to be Business/Professional and linked to a Facebook Page. After authorization, Instagram will be connected automatically.",
        },
        buttons: {
          cancel: "Cancel",
          connect: "Connect {{channel}}",
          connecting: "Connecting...",
        },
        errors: {
          noAppIdTitle: "Configuration pending!",
          noAppId: "To connect Facebook/Instagram you need to configure the Meta App ID. Go to Meta for Developers, create an App and set the REACT_APP_FACEBOOK_APP_ID variable in the system.",
        },
        success: {
          facebook: "Facebook Messenger connected successfully!",
          instagram: "Instagram Direct connected successfully!",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Service",
        },
        form: {
          message: "This contact is already being served:",
          user: "Agent",
          queue: "Queue",
          messageWait:
            "This contact is already waiting for service. Check the Waiting tab!",
          ticketId: "Ticket ID",
          status: "Status",
          createdAt: "Created at",
          updatedAt: "Updated at"
        },
        buttons: {
          goToTicket: "Go to Ticket",
          close: "Close",
          transferTicket: "Transfer Ticket"
        },
        status: {
          open: "Open",
          pending: "Pending",
          closed: "Closed"
        }
      },
      showTicketLogModal: {
        title: {
          header: "Ticket history",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue defined.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to queue.",
          closed: "closed the ticket.",
          reopen: "reopened the ticket.",
          redirect: " - redirected."
        },
        close: "Close",
        empty: "There are no records for this ticket yet.",
      },
      statusFilter: {
        title: "Status Filter",
        groups: "Groups",
        selected: "selected",
      },
      whatsappModal: {
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
          chatbot: "Chatbot",
          defaultFlow: "Default Flow",
        },
        form: {
          identitySectionTitle: "Identification",
          behaviorSectionTitle: "Behavior",
          tokenRefreshTooltip: "Generate new token",
          tokenCopyTooltip: "Copy token",
          queueIdImportMessagesDesc: "Queue where tickets created by the import will be routed. Set a specific queue to isolate imported history from active tickets.",
          sendIdQueueDesc: "Default queue to receive tickets from contacts not yet assigned to any queue. Works as an automatic fallback.",
          timeSendQueueDesc: "Time (in minutes) the system waits before moving an unassigned contact to the default queue above. Use 0 to disable automatic redirection.",
          queuesSectionTitle: "Service queues",
          queuesSectionDesc: "Queues (departments) that will receive tickets from this connection. Agents members of these queues will have access to the tickets.",
          queuesHelp: "Select one or more queues. Every message coming through this connection will be available to agents associated with these queues. If no queue is selected, only admins will see the tickets.",
          integrationSectionTitle: "External integration",
          integrationSectionDesc: "Routes messages from this connection to an external system (Typebot, Dialogflow, n8n, custom webhook, etc.) instead of internal queues.",
          integrationHelp: "When an integration is selected, messages are processed by the external system configured at Settings > Integrations. Useful for AI automations or custom bots. Note: choosing an integration clears the queues (they are mutually exclusive).",
          integrationsInfoTitle: "ⓘ How Queues and Integrations work",
          integrationsInfoText: "Each connection can route incoming messages in two ways:<ul><li><strong>Queues:</strong> distributes tickets among human agents organized into departments.</li><li><strong>External integration:</strong> sends messages to an automated system (bot, AI, webhook).</li></ul><strong>Important:</strong> the two options are mutually exclusive — choosing one automatically clears the other.",
          npsInfoTitle: "ⓘ What is NPS and how it works here",
          npsInfoText: "<strong>NPS (Net Promoter Score)</strong> is a survey sent to the customer <strong>after the ticket is closed</strong>, asking for a rating from <strong>0 to 10</strong> about the experience.<ul><li>The question is sent automatically by the system bot.</li><li>The received rating is stored and can be reviewed in reports.</li><li>If the customer doesn't reply, the system retries up to the configured maximum.</li><li>After the timeout, the rating ticket is closed automatically.</li></ul><strong>Important:</strong> to enable NPS sending, you must turn on <em>User rating</em> in Settings → Company.",
          npsSurveySectionTitle: "Rating survey",
          npsRulesSectionTitle: "Sending rules",
          ratingMessageDesc: "Text sent to the customer asking for the rating. Use a short, friendly sentence. The required scale is 0 to 10. Eg: 'On a scale of 0 to 10, how likely are you to recommend our service?'",
          maxUseBotQueuesNPSDesc: "Maximum number of times the rating question will be resent if the customer doesn't reply. Recommended: 2 or 3 attempts.",
          expiresTicketNPSDesc: "Time (in minutes) the system waits for a reply before automatically closing the rating ticket. Use 0 to never close automatically.",
          imageLabel: "Connection image",
          imageDesc: "Optional photo/video to visually identify this connection in your channels list.",
          nameDesc: "Internal connection name (visible only to your team). Use something descriptive like 'Sales Support' or 'BR Sales'.",
          defaultDesc: "When enabled, this becomes the default connection for automated outbound messages (campaigns, integrations, external API).",
          groupDesc: "Allows WhatsApp group messages to be received and open tickets in the platform. Disabled by default to reduce noise.",
          groupAsTicketDesc: "Defines how group messages are handled: 'Enabled' opens one ticket per group; 'Disabled' ignores or merges messages.",
          importSectionTitle: "Message import",
          importSectionDesc: "Pulls recent conversation history from the connected device. Configure carefully: the import is limited and may impact performance.",
          importInfoTitle: "ⓘ Read carefully before enabling",
          importInfoText: "Importing <strong>does not bring the entire WhatsApp history</strong> — only the messages still cached on the device.<ul><li><strong>Real limit:</strong> usually only the last weeks/months are recoverable, depending on device usage.</li><li><strong>Connection will be terminated</strong> on save and you will need to scan the QR code again.</li><li><strong>It can take a long time</strong> and put significant load on the server while running.</li><li><strong>Recommendation:</strong> for a clean start, prefer to <strong>create a new connection</strong> without import and let history build naturally.</li></ul>",
          importOldMessagesEnable: "Import messages from device",
          importOldMessagesEnableDesc: "Enables the attempt to import cached conversations from the phone when connecting. Use only if you really need previous history.",
          importOldMessages: "Import start date",
          importRecentMessages: "Import end date",
          importOldMessagesGroups: "Import group messages",
          importOldMessagesGroupsDesc: "Includes group conversation history in the import scope. Can significantly increase the volume of tickets created.",
          closedTicketsPostImported: "Close tickets after import",
          closedTicketsPostImportedDesc: "Automatically marks all tickets created by the import as closed. Useful to keep the agent queue clean.",
          name: "Name",
          tokenSectionTitle: "Token for external integration",
          tokenSectionDesc: "Use this token to authenticate API requests using this connection as the sender. Keep it secret.",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc:
            "Defines to which queue contacts without an assigned queue will be automatically redirected after the configured time.",
          default: "Default",
          group: "Allow groups",
          timeSendQueue: "Time in minutes to redirect to queue",
          importAlert:
            "ATTENTION: on save, the connection will be closed and you will need to scan the QR code again. Import only pulls what is cached on the device — not the full WhatsApp history.",
          groupAsTicket: "Treat groups as tickets",
          timeCreateNewTicket: "Create new ticket in x minutes",
          maxUseBotQueues: "Send bot x times",
          timeUseBotQueues: "Send bot in x minutes",
          expiresTicket: "Close open chats after x minutes",
          expiresTicketNPS:
            "Close chats awaiting rating after x minutes",
          maxUseBotQueuesNPS:
            "Maximum number of times the rating will be sent",
          closeLastMessageOptions1: "From agent/Client",
          closeLastMessageOptions2: "From agent",
          outOfHoursMessage: "Out-of-hours message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Hide message deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Rating message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity message",
          timeInactiveMessage:
            "Time in minutes to send inactivity warning",
          whenExpiresTicket:
            "Close open chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          prompt: "Prompt",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue to import messages"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          minutes: "minutes",
        },
        messages: {
          clickSaveToRegister: "Click save to register changes",
        },
        flowBuilder: {
          welcomeFlow: "Welcome flow",
          welcomeFlowLabel: "Select a welcome flow",
          welcomeFlowDescription: "Triggered when a brand-new contact (not yet in your database) sends the first message to this connection.",
          welcomeFlowHelp: "Use to introduce the company, ask for the name, collect initial data or automatically route the customer to a queue. The flow must be created in FlowBuilder before appearing here. Leave 'Disabled' if you prefer new contacts to fall directly into the default queue.",
          defaultResponseFlow: "Default response flow",
          defaultResponseFlowLabel: "Select a default response flow",
          defaultResponseFlowDescription: "Triggered for any message that does NOT match a configured keyword. Warning: it is also triggered when the service has been closed for more than 6 hours.",
          defaultResponseFlowHelp: "Use to reply automatically when the customer writes something unexpected, or after long inactivity. Beware: if misconfigured it can confuse customers in active conversations. A short flow that simply asks them to come back during business hours is recommended. Leave 'Disabled' to silence automatic replies.",
          infoTitle: "ⓘ What is the Default Flow",
          infoText: "Allows you to link this connection to automated flows created in <strong>FlowBuilder</strong>. There are two triggers:<ul><li><strong>Welcome flow:</strong> runs on the first message from a new contact.</li><li><strong>Default response flow:</strong> runs when a message doesn't match any keyword or when the service has been closed for more than 6 hours.</li></ul><strong>To configure:</strong> first create the flow in <em>FlowBuilder</em> from the side menu, then select it here. Flows only execute while this connection is online.",
          title: "Default flow",
          save: "Save",
          updatedSuccess: "Default flows updated",
          deleteConfirmation: "Are you sure you want to delete this flow? All related integrations will be lost.",
        },
        success: "Connection saved successfully.",
        errorSendQueue:
          "A time to redirect to queue was provided, but no queue was selected. Both fields must be filled.",
        errorExpiresNPS:
          "You must specify a time for rating when using NPS.",
        errorRatingMessage:
          "You must provide a rating message when using NPS.",
      },
      qrCode: {
        message: "Scan the QR code to start the session",
      },
      qrcodeModal: {
        title: "Connect WhatsApp",
        intro: "Use WhatsApp on your phone to scan the code on the right and connect this session. The process takes only a few seconds.",
        step1: "Open <strong>WhatsApp</strong> on your phone.",
        step2: "Tap <strong>More options</strong> (Android) or <strong>Settings</strong> (iPhone).",
        step3: "Select <strong>Linked devices</strong> and then <strong>Link a device</strong>.",
        step4: "Point your phone camera at the QR Code on the right.",
        statusReady: "Ready to scan",
        waiting: "Waiting for QR Code..."
      },
      forbiddenPage: {
        accessDenied: "Oops! Access Denied!",
        buttons: {
          back: "Back"
        }
      },
      contacts: {
        title: "Contacts",
        subtitleCount: "contacts",
        toasts: {
          deleted: "Contact deleted successfully!",
        },
        searchPlaceholder: "Search...",
        filters: {
          title: "Filters",
          any: "Any",
          clearAll: "Clear filters",
          apply: "Apply",
          tagsLabel: "Tags",
        },
        confirmationModal: {
          deleteTitle: "Delete ",
          importTitlte: "Import contacts",
          exportContact: "Export contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related services will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
          edit: "Edit",
          block: "Block",
          unblock: "Unblock",
          delete: "Delete",
          startChat: "Start chat",
        },
        status: {
          active: "Active",
          inactive: "Inactive",
        },
        phantomCleanup: {
          button: "Clean phantoms",
          help: "Why does this happen?",
          confirmTitle: "Clean phantom contacts",
          confirmMessage: "{{count}} phantom contacts were found. They will be permanently removed from the database. Continue?",
          noneFound: "No phantom contacts found in your database. All clean!",
          deletedSuccess: "phantom contacts removed",
          helpTitle: "Why do phantom contacts appear?",
          helpIntro: "Phantom contacts are entries with invalid numbers, no name, or auto-created by the system without matching a real WhatsApp contact.",
          helpWhy: "Why does this happen?",
          helpReason1: "It's a limitation of the Baileys library (which connects to WhatsApp Web). When WhatsApp sends sync events — broadcasts, lists, status — the library can interpret those identifiers as new contacts, even when they don't represent real people.",
          helpReason2: "Result: entries appear with very short numbers, weird prefixes (555000…, 120363…), or not enough digits to be a valid phone.",
          helpFixTitle: "What does this cleanup do?",
          helpFixBody: "Identifies contacts with invalid numbers (off the E.164 format, repeated sequences, suspicious prefixes) or auto-created outside the address book, and permanently removes them. Legitimate contacts are not affected.",
          helpClose: "Got it",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          email: "Email",
          actions: "Actions",
          lastMessage: "Last Message",
          status: "Status",
          followUp: "Follow Up",
          tags: "Tags",
          products: "Product",
          payment: "Payment",
          attendant: "Attendant",
          selectAll: "Select all contacts",
          selectContact: "Select contact {{name}}",
        },
        productStatus: {
          pending: "Pending",
          completed: "Completed",
          cancelled: "Cancelled",
          refunded: "Refunded",
          in_progress: "In Progress",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
          importExport: "Import/Export"
        },
        bulkActions: {
          deleteSelected: "Delete Selected ({{count}})",
          deleteConfirmTitle: "Are you sure you want to delete {{count}} selected contacts?",
          deleteConfirmMessage: "This action is irreversible.",
          deleteSuccess: "Selected contacts deleted successfully!",
          blockContact: "Contact blocked",
          unblockContact: "Contact unblocked",
          selectConnectionToImport: "Choose which connection to import from"
        },
        tagsFilter: {
          title: "Filter by Tags",
          placeholder: "Select tags...",
          noTags: "No tags available",
          clearFilters: "Clear filters",
          selectedTags: "Selected tags"
        },
        validation: {
          nameRequired: "Name is required",
          numberRequired: "Number is required",
          emailRequired: "Email is required",
          invalidEmail: "Invalid email",
          numberExists: "This number already exists",
          emailExists: "This email already exists",
          invalidNumber: "Invalid number",
          numberTooShort: "Number too short",
          numberTooLong: "Number too long",
          nameTooShort: "Name too short",
          nameTooLong: "Name too long",
          tooShort: "Too short!",
          tooLong: "Too long!",
          required: "Required"
        },
      },
      contactImport: {
        title: "Import contacts from file",
        subtitle: "Upload an XLS, XLSX, CSV or TXT file to import contacts in bulk",
        validation: {
          noNumberField: "No contact number field was selected",
          noNameField: "No contact name field was selected",
          noContactsSelected: "No contact selected",
          fieldAlreadySelected: "The field {{field}} has already been selected."
        },
        messages: {
          successComplete: "Import completed successfully",
          successWithErrors: "Import completed successfully, but there were some errors",
          importing: "Importing... Please wait",
          processing: "Processing file...",
          invalidFile: "Invalid file!",
          contactsCreated: "contacts created",
          contactsIgnored: "contacts ignored (invalid number or not marked for update)"
        },
        fields: {
          name: "Name",
          number: "Number",
          email: "E-mail",
          tags: "Tags",
          followUp: "Follow Up (Notes)",
          productName: "Product (Name)",
          productStatus: "Product (Status)"
        },
        buttons: {
          downloadModel: "Download template",
          validateWhatsApp: "Validate contacts on WhatsApp",
          importContacts: "Import contacts",
          cancel: "Cancel",
          back: "Back"
        },
        dropzone: {
          clickOrDrag: "Click or drag a file",
          importantNote: "* Important: Only files with these extensions are accepted: xls, xlsx, csv, txt"
        },
        sheetName: "Contacts",
        sampleContact: {
          name: "John",
          number: "15551234567",
          email: "john@email.com",
          tags: "customer, vip",
          followUp: "",
          productName: "Marketing Course",
          productStatus: "completed"
        },
        filters: {
          filter: "Filter",
          clearAll: "Clear filters",
          noResults: "No results found"
        }
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward messages to",
        searchPlaceholder: "Search name or number",
        recentConversations: "Recent conversations",
        createContact: "Create contact \"{{name}}\"",
        typeToSearch: "Type to search contacts.",
        selectedMessage: "{{count}} selected message",
        selectedMessages: "{{count}} selected messages",
        selectedRecipient: "{{count}} selected recipient",
        selectedRecipients: "{{count}} selected recipients",
        sending: "Sending {{target}}...",
        buttons: {
          ok: "Forward",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
          model: "Model",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add Prompt",
          edit: "Edit Prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        validation: {
          tooShort: "Too short!",
          tooLong: "Too long!",
          required: "Required",
          promptDescription: "Describe the training for Artificial Intelligence",
          invalidModel: "Invalid model",
          informModel: "Enter the model",
          minTokens: "Minimum 10 tokens",
          maxTokens: "Maximum 4096 tokens",
          informMaxTokens: "Enter the maximum number of tokens",
          minZero: "Minimum 0",
          maxOne: "Maximum 1",
          informTemperature: "Enter the temperature",
          informApiKey: "Enter the API Key",
          informQueue: "Enter the queue",
          minMessages: "Minimum 1 message",
          maxMessages: "Maximum 50 messages",
          informMaxMessages: "Enter the maximum number of messages",
          informVoiceMode: "Enter the voice mode"
        },
        errors: {
          savePrompt: "Error saving the prompt"
        },
        models: {
          "gpt-4.1": "GPT 4.1",
          "gpt-4.1-mini": "GPT 4.1 Mini",
          "gpt-4.1-nano": "GPT 4.1 Nano",
          "gpt-4o": "GPT 4o",
          "gpt-4o-mini": "GPT 4o Mini",
          "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legacy)",
          "gemini-2.5-pro": "Gemini 2.5 Pro",
          "gemini-2.5-flash": "Gemini 2.5 Flash",
          "gemini-2.0-flash": "Gemini 2.0 Flash",
          "gemini-2.0-pro": "Gemini 2.0 Pro",
        },
        voices: {
          text: "Text",
          francisca: "Francisca",
          antonio: "Antonio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fabio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Leticia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valerio",
          yara: "Yara"
        }
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Department/Queue",
          max_tokens: "Maximum Response Tokens",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Prompt",
        },
        errors: {
          noPermission: "This company does not have permission to access this page! We are redirecting you."
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
          createCard: "Create card",
        },
        form: {
          kanbanLane: "Kanban column",
          kanbanLaneHelp: "Select which column the card will be created in.",
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "WhatsApp Number",
          optional: "optional",
          email: "Email",
          extraName: "Field name",
          extraValue: "Description",
          chatBotContact: "Disable chatbot",
          followUp: "Follow Up (Notes)",
          followUpPlaceholder: "Notes about the contact...",
          termsLGDP: "LGPD terms accepted on:",
          whatsapp: "Source Connection: ",
          numberPlaceholder: "5513912344321",
          emailPlaceholder: "Email address",
          products: "Products",
          productName: "Product name",
          tags: "Tags",
          tagsPlaceholder: "Select or create tags",
        },
        buttons: {
          addExtraInfo: "Add information",
          addProduct: "Add",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      contactTagListModal: {
        title: "Contacts",
        table: {
          id: "ID",
          name: "Name",
          number: "Number",
          actions: "Actions"
        }
      },
      flowbuilder: {
        title: "Conversation Flows",
        subtitle: "Manage conversation flows and service automations",
        subMenus: {
          campaign: "Campaign Flow",
          conversation: "Conversation Flow"
        },
        buttons: {
          add: "Add Flow",
          editName: "Edit name",
          editFlow: "Edit flow",
          duplicate: "Duplicate",
          delete: "Delete"
        },
        table: {
          status: "Status"
        },
        status: {
          active: "Active",
          inactive: "Inactive"
        },
        toasts: {
          deleteSuccess: "Flow deleted successfully",
          duplicateSuccess: "Flow duplicated successfully"
        },
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this flow? All related integrations will be lost.",
          duplicateTitle: "Do you want to duplicate the flow {flowName}?",
          duplicateMessage: "Are you sure you want to duplicate this flow?"
        }
      },
      knowledgeBase: {
        title: "Knowledge Base",
        tabs: {
          rag: "Knowledge Base (RAG)",
          qualification: "Agent Qualification",
        },
        rag: {
          title: "Knowledge Base",
          subtitle: "Sources and content used by the agent to answer with RAG",
          actions: {
            refresh: "Refresh",
            newBase: "New RAG Base",
            createFirst: "Create first base",
            createBase: "Create Base",
            cancel: "Cancel",
            processing: "Processing...",
            indexKnowledge: "Index Knowledge",
          },
          stats: {
            created: "Bases created",
            indexed: "Indexed bases",
            totalChunks: "Total chunks",
          },
          empty: {
            title: "No knowledge base created",
            description: "Create a base and upload documents (PDF, TXT, CSV) or paste text. The AI agent will use this information to answer your customers.",
          },
          table: {
            name: "Name",
            type: "Type",
            file: "File",
            createdAt: "Created at",
            actions: "Actions",
          },
          status: {
            pending: "Pending",
            processing: "Processing",
            indexed: "Indexed",
            error: "Error",
            active: "Active",
            importing: "Importing",
          },
          sourceTypes: {
            text: "Text",
            pdf: "PDF",
            csv: "CSV",
            url: "URL",
          },
          tooltips: {
            index: "Index content",
            delete: "Delete",
          },
          dialogs: {
            newBaseTitle: "New Knowledge Base",
            indexTitle: "Index Content - {{name}}",
            indexDescription: "Choose how to add content. It will be split into chunks and indexed with embeddings for semantic search by the AI agent.",
            processingDescription: "Processing intelligence... This may take a few minutes.",
          },
          form: {
            name: "Name",
            namePlaceholder: "E.g.: Product Catalog, FAQ, Policies...",
            description: "Description",
            descriptionPlaceholder: "Describe the content of this base...",
            sourceType: "Source Type",
            chunkSize: "Chunk Size",
            recommended512: "Recommended: 512",
            recommended50: "Recommended: 50",
            apiKeyHelp: "Required to generate embeddings",
            filePlaceholder: "Click to select file (PDF, TXT, CSV...)",
            content: "Content",
            contentPlaceholder: "Paste the text here...",
            siteUrl: "Website URL",
            siteUrlHelp: "Enter the full URL",
          },
          ingestModes: {
            file: "File",
            text: "Text",
          },
          toasts: {
            created: "Base created successfully!",
            deleted: "Base deleted!",
            fillContent: "Fill in the content, select a file, or enter a URL.",
            indexed: "Content indexed successfully!",
          },
          confirm: {
            deleteBase: "Are you sure you want to delete this knowledge base?",
          },
        },
        datasets: {
          titles: {
            catalogs: "Catalogs",
            qualification: "Agent Qualification",
          },
          subtitles: {
            catalogs: "Structured data for querying products, prices, and availability",
            qualification: "Fields and datasets the agent should fill during service",
          },
          dialogs: {
            newCatalogTitle: "New Catalog",
            newQualificationTitle: "New Qualification",
            importTitle: "Import Data - {{name}}",
            processingImport: "Processing import...",
          },
          form: {
            name: "Name",
            catalogName: "Catalog name",
            description: "Description (optional)",
            fieldName: "Field name",
            type: "Type",
          },
          actions: {
            addField: "Add field",
            refresh: "Refresh",
            newCatalog: "New Catalog",
            newQualification: "New Qualification",
            createCatalog: "Create Catalog",
            createQualification: "Create Qualification",
            createFirstCatalog: "Create first catalog",
            createFirstQualification: "Create first qualification",
            importData: "Import Data",
            cancel: "Cancel",
          },
          stats: {
            datasets: "Datasets",
            totalRows: "Total rows",
          },
          empty: {
            catalogTitle: "No catalog created",
            qualificationTitle: "No qualification created",
            catalogDescription: "Create a catalog and import data (CSV, Google Sheets). The AI agent will use this data to query products, prices, and availability.",
            qualificationDescription: "Create the fields the AI agent should fill during service (e.g. name, interest, lead temperature).",
          },
          table: {
            name: "Name",
            source: "Source",
            columns: "Columns",
            rows: "Rows",
            createdAt: "Created at",
            type: "Type",
            mode: "Mode",
            actions: "Actions",
          },
          tooltips: {
            viewData: "View data",
            importData: "Import data",
            delete: "Delete",
            resyncGoogleSheets: "Resync Google Sheets",
          },
          status: {
            pending: "Pending",
            processing: "Processing",
            indexed: "Indexed",
            error: "Error",
            active: "Active",
            importing: "Importing",
          },
          columnTypes: {
            text: "Text",
            number: "Number",
            currency: "Currency",
            date: "Date",
            boolean: "Yes/No",
            url: "URL / Link",
            image: "Image (URL)",
            email: "Email",
            phone: "Phone",
            select: "Options list",
            textarea: "Long text",
            json: "JSON",
          },
          importModes: {
            csv: "CSV file",
          },
          modes: {
            ask: "Question",
            internal: "Internal",
          },
          toasts: {
            created: "Dataset created!",
            deleted: "Dataset deleted!",
            noSourceUrl: "This dataset has no source URL to resync.",
            fillImportSource: "Fill in the Google Sheets URL or select a CSV file.",
            imported: "Data imported successfully!",
            resyncing: "Resyncing Google Sheets data...",
            resynced: "Data resynced!",
            columnAdded: "Column added!",
          },
          confirm: {
            deleteDataset: "Delete this dataset and all its data?",
            removeColumn: "Remove the column \"{{column}}\"? Data in this column will be lost.",
          },
          form: {
            name: "Name",
            catalogName: "Catalog name",
            description: "Description (optional)",
            fieldName: "Field name",
            type: "Type",
            googleSheetsLink: "Google Sheets link",
            csvPlaceholder: "Click to select CSV file",
            newFieldPlaceholder: "New field...",
          },
        },
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Default flow",
        title: {
          add: "Add Flow",
          edit: "Edit Flow"
        },
        validation: {
          tooShort: "Too short!",
          tooLong: "Too long!",
          required: "Enter a name!"
        }
      },
      queueModal: {
        title: {
          queueData: "Queue data",
          text: "Business hours",
          add: "Add queue",
          edit: "Edit queue",
          confirmationDelete:
            "Are you sure? All integration options will be deleted.",
        },
        info: {
          intro: {
            title: "ⓘ What is a queue",
            text: "<strong>Queues</strong> (departments) organize the service. Each connection can be linked to one or more queues, and agents only see tickets from queues they are members of.<ul><li>Define <strong>name</strong> and <strong>color</strong> to visually identify the queue.</li><li>The <strong>greeting message</strong> is sent when the customer enters this queue.</li><li>The <strong>router</strong> automatically distributes tickets among online agents.</li></ul><strong>For advanced automation</strong>, use <em>FlowBuilder</em> and select the flow on the WhatsApp connection."
          }
        },
        sections: {
          identity: "Identification",
          identityDesc: "Name, color and display order of the queue.",
          behavior: "Behavior",
          behaviorDesc: "Defines automatic actions when the ticket enters or is assigned to this queue.",
          messages: "Automatic messages",
          messagesDesc: "Texts sent automatically at specific moments of the service."
        },
        help: {
          name: "Internal name of the queue. Appears in lists and reports. Use something descriptive (e.g.: 'Support', 'BR Sales').",
          color: "Color of the queue's visual tag. Appears in ticket lists, chat and reports.",
          orderQueue: "Numerical position of this queue in the bot menus. Queues with lower numbers appear first. Use 0 to hide.",
          closeTicket: "When enabled, the ticket is automatically closed at the end of the bot flow. Useful for FAQs and 100% automated service.",
          rotate: "Automatic router: redistributes tickets without an assigned agent among online agents in the queue every X minutes.",
          tempoRoteador: "Interval (in minutes) between each automatic redistribution. Recommended: 5 to 10 minutes.",
          greetingMessage: "Text sent to the customer when the ticket enters this queue. Can include variables like {{name}} (contact name) and {{queue}}."
        },
        form: {
          name: "Name",
          color: "Color",
          orderQueue: "Queue order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          outOfHoursMessage: "Out-of-hours message",
          token: "Token",
          integrationId: "Integration",
          fileListId: "File list",
          closeTicket: "Close ticket",
          queueType: "Menu type",
          message: "Return message",
          queue: "Queue for transfer",
          integration: "Integration",
          file: "File list",
          selectFile: "Select a file",
          timeOptions: {
            minutes2: "2 minutes",
            minutes5: "5 minutes",
            minutes10: "10 minutes",
            minutes15: "15 minutes",
            minutes30: "30 minutes",
            minutes45: "45 minutes",
            minutes60: "60 minutes",
          },
        },
        validations: {
          tooShort: "Too short!",
          tooLong: "Too long!",
          required: "Required",
          mustHaveFriends: "Must have friends",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip:
            "If there is only one option, it will be chosen automatically, causing the bot to respond with the option's message and proceed",
          selectOption: "Select an option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          toolTipMessageTitle:
            "The message is mandatory to proceed to the next level",
          toolTipMessageContent:
            "The message is mandatory to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
          addOptions: "Add options",
          confirmationDelete: "Are you sure? All internal options will also be deleted",
          messageLabel: "Message:",
          toolTipMessage: "The message is mandatory to proceed to the next level",
          toolTipContent: "If the message is not defined, the bot will not proceed",
        },
        serviceHours: {
          dayWeek: "Day of the week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
        general: {
          none: "None",
          message: "Message:",
        },
      },
      colorBoxModal: {
        title: "Choose a color",
        eyeDropper: "Pick color from screen",
        buttons: {
          cancel: "Cancel",
          ok: "OK",
        },
        tooltips: {
          copy: "Copy color",
          copied: "Copied!",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add project",
          edit: "Edit project",
        },
        info: {
          intro: {
            title: "ⓘ What are flow integrations",
            text: "Integrations connect this platform to external automation systems:<ul><li><strong>N8N:</strong> visual workflow orchestrator — you create automations with triggers, conditions and actions that fire on every received message.</li><li><strong>Typebot:</strong> conversational chatbot builder — the customer talks to a guided flow of pre-defined questions and answers.</li></ul><strong>How it works:</strong> when receiving a message, the system sends the data to the configured URL and processes the returned response. The integration is selected per connection on the <em>Integrations</em> tab of the whatsapp."
          }
        },
        sections: {
          type: "Integration type",
          typeDesc: "Choose the external service that will process the messages.",
          n8nConfig: "N8N configuration",
          n8nConfigDesc: "Provide a name to identify this integration and the webhook URL that will receive the events.",
          typebotConnection: "Typebot connection",
          typebotConnectionDesc: "Identify the integration and provide the server + slug of the published Typebot.",
          typebotBehavior: "Conversation behavior",
          typebotBehaviorDesc: "Controls expiration time, delay between messages and keywords that close or restart the bot."
        },
        help: {
          name: "Internal name to identify this integration in the list (e.g.: 'N8N support bot').",
          urlN8N: "Full webhook URL of your N8N workflow. Find at: Webhook node → 'Production URL'. Must be publicly accessible by this platform's backend.",
          urlTypebot: "Base URL of the Typebot server (e.g.: 'https://typebot.io' for the official version or your self-hosted instance domain).",
          typebotSlug: "Public identifier of the published bot. Find on the Share tab of your Typebot — it's the final part of the URL (e.g.: 'my-bot-123').",
          typebotExpires: "Time (in hours) the bot session remains active without a new message from the contact. After this period, the flow restarts. Use 0 to never expire.",
          typebotDelayMessage: "Time (in ms) the bot waits before sending each response. Simulates human typing. Recommended: 1000-2000ms.",
          typebotKeywordFinish: "Word that, when sent by the customer, immediately ends the bot flow and releases human service (e.g.: 'exit', 'agent').",
          typebotKeywordRestart: "Word that restarts the bot flow from scratch (e.g.: 'restart', 'menu'). The customer returns to the first question of the Typebot.",
          typebotUnknownMessage: "Message the bot sends when it receives a response it doesn't understand or that doesn't match any flow option (e.g.: 'I didn't understand, can you rephrase?').",
          typebotRestartMessage: "Message sent automatically when the flow is restarted by the keyword above (e.g.: 'Let's start over!')."
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          urlN8NWebhook: "Webhook URL (from N8N)",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Time in minutes for a conversation to expire",
          typebotKeywordFinish: "Word to close the ticket",
          typebotKeywordRestart: "Word to restart the flow",
          typebotRestartMessage: "Message on restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Interval (ms) between messages",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        languages: {
          "pt-BR": "Portuguese",
          "en": "English",
          "es": "Spanish",
        },
        instructions: {
          n8nTitle: "How to set up N8N integration (step by step)",
          n8nStep1: "In your N8N, create a new workflow and add a \"Webhook\" node as the first node (trigger).",
          n8nStep2: "In the Webhook node, set the method to POST. N8N will generate a URL like: https://your-n8n.com/webhook/abc123",
          n8nStep3: "Copy that webhook URL and paste it in the \"Webhook URL\" field above.",
          n8nStep4: "Build the rest of your workflow in N8N (e.g., connect to an AI, query a database, send an email, etc).",
          n8nStep5: "After saving here, go to Connections (WhatsApp) or Queues and link this integration. Every message received on that connection/queue will be automatically sent to N8N.",
          n8nDataTitle: "Data that N8N will receive:",
          n8nReplyTitle: "How N8N replies to the customer:",
          n8nReplyOption1: "Option 1 (simplest) - In the last node of the workflow, use \"Respond to Webhook\" and return:",
          n8nReplyOption2: "Option 2 (more control) - Use the \"HTTP Request\" node to call the API directly. The apiToken and apiUrl are already included in the webhook:",
          n8nTip: "Tip: The API token is in Connections > edit the WhatsApp connection > Token field. But with Option 1 above, you don't need to worry about it - just return the text in \"reply\".",
          webhookTitle: "How to set up the Webhook",
          webhookStep1: "Configure your external system to receive POST requests at the desired endpoint.",
          webhookStep2: "Paste the endpoint URL in the field above. Each received message will be sent as a POST with contact, ticket, and message data.",
          webhookStep3: "If the endpoint returns { \"reply\": \"text\" } in the response, the system will automatically send that message to the customer on WhatsApp.",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
        },
      },
      userModal: {
        warning:
          "To import messages, you need to scan the QR code again!!!",
        title: {
          add: "Add user",
          edit: "Edit user",
          updateImage: "Update image",
          removeImage: "Delete image",
        },
        form: {
          name: "Name",
          none: "None",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell message",
          profile: "Profile",
          startWork: "Work start",
          endWork: "Work end",
          whatsapp: "Default Connection",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View tickets without queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View conversations from other queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View other users' conversations",
          userClosePendingTicket: "Allow closing pending tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Service Panel",
          allowConnections: "Allow actions on connections",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
        },
        success: "User saved successfully.",
      },
      companyModal: {
        title: {
          add: "Add company",
          edit: "Edit company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
          status: "Active",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
        validations: {
          nameRequired: "Name is required",
          emailInvalid: "Email is invalid",
          emailRequired: "E-mail is required",
          passwordRequired: "Password is required",
          tooShort: "Too short!",
          tooLong: "Too long!",
        },
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Schedule Date",
          sentAt: "Sent Date",
          assinar: "Send Signature",
          date: "Date",
          time: "Time",
          timezoneHelper: "Timezone: {{tz}} | Current time: {{time}}",
          timezoneHelperShort: "Timezone: {{tz}}"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add schedule"
        },
        success: "Schedule saved successfully.",
        validations: {
          tooShort: "Message too short",
          required: "Required"
        },
        toasts: {
          deleted: "Media removed successfully."
        },
        confirmationModal: {
          deleteTitle: "Delete Media",
          deleteMessage: "Are you sure you want to delete this media?"
        },
        status: {
          sending: "Sending",
          pending: "Pending",
          sent: "Sent",
          error: "Send Error"
        },
        recurrence: {
          title: "Recurrence",
          description: "You can choose to send the message recurrently and choose the interval. If it's a one-time message, don't change anything in this section.",
          interval: "Interval",
          intervalValue: "Interval Value",
          sendTimes: "Send how many times",
          intervalTypes: {
            days: "Days",
            weeks: "Weeks",
            months: "Months",
            minutes: "Minutes"
          },
          businessDays: {
            normal: "Send normally on non-working days",
            before: "Send one working day before",
            after: "Send one working day after"
          }
        },
        calendar: {
          messages: {
            date: "Date",
            time: "Time",
            event: "Event",
            allDay: "All Day",
            week: "Week",
            work_week: "Schedules",
            day: "Day",
            month: "Month",
            previous: "Previous",
            next: "Next",
            yesterday: "Yesterday",
            tomorrow: "Tomorrow",
            today: "Today",
            agenda: "Agenda",
            noEventsInRange: "No schedules in the period.",
            showMore: "more"
          }
        },
        permissions: {
          noAccess: "This company doesn't have permission to access this page! We are redirecting you."
        }
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
        },
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in hours to redirect to lane",
          timeOnLane: "Time on lane",
          days: "Days",
          hours: "Hours",
          minutes: "Minutes",
          seconds: "Seconds",
          nextLaneId: "Next lane",
          greetingMessageLane: "Lane greeting message",
          rollbackLaneId: "Return to Lane after resuming service"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        validation: {
          tooShort: "Too short!",
          required: "Required"
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
      },
      fileModal: {
        title: {
          add: "Add file list",
          edit: "Edit file list",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add file",
        },
        form: {
          name: "File list name",
          message: "List details",
          fileOptions: "File list",
          extraName: "Message to send with file",
          extraValue: "Option value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
        deleteConversationTitle: "Delete Conversation",
        deleteConversationMessage: "This action cannot be reversed, confirm?",
        messagePlaceholder: "Type your message...",
        sendButtonTooltip: "Send message",
        noMessagesYet: "No messages yet. Start the conversation!",
        loadingMessages: "Loading messages...",
        popover: {
          buttonTooltip: "Internal conversations",
          loading: "Loading conversations...",
          noChats: "No conversations available",
          notificationNotSupported: "This browser doesn't support notifications",
          accessibilityLabel: "Internal conversations list",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ DRAG AND DROP FILES IN THE FIELD BELOW ⬇️",
          titleFileList: "File(s) list",
        },
      },
      chatInternal: {
        new: "New",
        tabs: {
          chats: "Chats",
          messages: "Messages",
        },
        form: {
          titleLabel: "Title",
          titlePlaceholder: "Title",
        },
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolved: "Resolved",
        },
        toasts: {
          deleted: "The service you were in was deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Open" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search services and messages",
          filterConnections: "Filter by Connection",
          filterConnectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          schedule: "Schedule",
          deleteTicket: "Delete Ticket",
          quickMessageFlash: "Quick responses",
        },
        noContactName: "(no contact)",
        noDepartment: "No department",
        group: "Group",
        transferTooltip: "Transfer Ticket",
        closedTicket: {
          closedMessage: "Close Ticket with Farewell Message",
          closedNotMessage: "Close Ticket without Farewell Message",
        },
      },
      messages: {
        download: "Download",
        today: "TODAY",
        contact: "Contact",
        forwarded: "Forwarded",
        deletedByContact: "🚫 This message was deleted by contact &nbsp;",
        deletedMessage: "🚫 _Deleted message_ ",
        deletedBySender: "🚫 This message was deleted &nbsp;",
        youReacted: "You reacted... ",
        sayHello: "Say hello to your new contact!",
        dropFile: "Drop file here",
        facebookPolicy: "You have 24h to respond after receiving a message, according to Facebook's policies.",
        defaultMetaMessage: "Hello! I'm interested and would like more information, please.",
      },
      ticketsResponsive: {
        search: {
          searchInMessagesTooltip: "Check to also search message contents (slower)",
        },
        filter: {
          all: "All",
          unreplied: "Unreplied",
          title: "Filters",
          queues: "Queues",
          tags: "Tags",
          connections: "Connections",
          status: "Status",
          users: "Users",
          showTags: "Show tags",
          hideTags: "Hide tags",
        },
        sort: {
          ascending: "Ascending",
          descending: "Descending",
        },
      },
      contactForm: {
        validation: {
          tooShort: "Too short!",
          tooLong: "Too long!",
          required: "Required",
          invalidEmail: "Invalid email",
        },
        placeholders: {
          number: "5513912344321",
          email: "Email address",
        },
      },
      common: {
        image: "image",
      },
      messageInputResponsive: {
        privateMessage: {
          suffix: "Private Message",
        },
        type: {
          document: "Document",
          buttons: "Buttons",
        },
        tooltip: {
          toggleSignature: "Enable/Disable Signature",
          toggleComments: "Enable/Disable Comments",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No user found with this name",
        msgTransfer: "Notes - internal message, not sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        called: "Called",
        today: "Today",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "Serving",
        groupingHeader: "Groups",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage:
          "No service found with this status or search term",
        noQueue: "No Queue",
        draft: "Draft:",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Kanban Options",
          showAll: "Show All",
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select department",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
        form: {
          contact: "Contact",
          queue: "Queue",
          message: "Initial message",
          contactPlaceholder: "Search contact...",
          queuePlaceholder: "Select queue...",
          messagePlaceholder: "Optional initial message..."
        },
        validation: {
          contactRequired: "You must select a contact",
          queueRequired: "You must select a queue"
        }
      },
      SendContactModal: {
        title: "Send contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          chatsTempoReal: "Panel",
          tickets: "Services",
          quickMessages: "Quick Responses",
          contacts: "Contacts",
          queues: "Queues",
          flowbuilder: "Flowbuilder",
          tags: "Tags",
          administration: "Administration",
          companies: "Companies",
          users: "Users",
          settings: "Settings",
          files: "File List",
          helps: "Help",
          messagesAPI: "API",
          schedules: "Schedules",
          campaigns: "Campaigns",
          announcements: "Announcements",
          annoucements: "Announcements",
          knowledgeBase: "Knowledge Base",
          agentQualification: "Agent Qualification",
          chats: "Internal Chat",
          financeiro: "Financial",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "Kanban",
          prompts: "Prompts",
          allConnections: "Manage connections",
          reports: "Reports",
          management: "Analytics"
        },
        appBar: {
          search: "Search...",
          user: {
            profile: "Profile",
            logout: "Log out",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token:
              "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          notRegister: "No record",
          refresh: "Refresh",
          themeLight: "Light mode",
          themeDark: "Dark mode",
          volume: "Volume",
          volumeNotifications: "Notification volume",
          installPwa: {
            title: "Add to home screen",
            iosStep1: "Tap the Share button (square icon with an upward arrow)",
            iosStep2: "Scroll and tap \"Add to Home Screen\"",
            iosStep3: "Tap \"Add\"",
            androidStep1: "Tap the browser menu ⋮ (Chrome three-dot menu)",
            androidStep2: "Tap \"Add to Home screen\" or \"Install app\"",
            androidStep3: "Confirm by tapping \"Install\"",
            gotIt: "Got it",
          },
          mobileMenu: {
            title: "Menu",
            language: "Language",
            darkMode: "Dark mode",
            lightMode: "Light mode",
            volume: "Volume",
            announcements: "Announcements",
            chat: "Chat",
            addToHomeScreen: "Add to home screen",
            understood: "Got it",
            installIos1: "Tap the",
            installIosShare: "Share",
            installIos1b: "button (square icon with upward arrow)",
            installIos2: "Scroll and tap",
            installIos2b: "Add to Home Screen",
            installIos3: "Tap",
            installIos3b: "Add",
            installAndroid1: "Tap the browser menu",
            installAndroid1b: "(three dots in Chrome)",
            installAndroid2: "Tap",
            installAndroid2b: "Add to Home screen",
            installAndroid2c: "Install app",
            installAndroid3: "Confirm by tapping",
            installAndroid3b: "Install",
          },
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
      },
      messagesAPI: {
        title: "API",
        subtitle: "Integrate external systems to send messages via API.",
        methodsSubtitle: "Available endpoints and rules for the destination number.",
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File name",
          media: "File",
          token: "Registered Token",
        },
        API: {
          title: "Documentation for sending messages",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMedia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1:
              "Before sending messages, you must register the token linked to the connection that will send the messages. <br />To register, go to the 'Connections' menu, click the edit button for the connection, and enter the token in the appropriate field.",
            comments2:
              "The number for sending must not have a mask or special characters and must consist of:",
            codeCountry: "Country Code",
            code: "Area Code",
            number: "Number",
          },
          text: {
            title: "1. Text Messages",
            instructions:
              "Below is the list of information required to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions:
              "Below is the list of information required to send media messages:",
          },
        },
        messages: {
          noPermission: "This company does not have permission to access this page! We are redirecting you.",
          success: "Message sent successfully",
        },
        form: {
          send: "Send",
          testSend: "Send test",
          chooseFile: "Choose file",
          noFile: "No file selected",
        },
        documentation: {
          endpoint: "Endpoint: ",
          method: "Method: ",
          post: "POST",
          headers: "Headers: ",
          headersTextAuth: "Authorization Bearer (registered token) and Content-Type (application/json)",
          headersMediaAuth: "Authorization Bearer (registered token) and Content-Type (multipart/form-data)",
          body: "Body: ",
          formData: "FormData: ",
          bodyExample: "{\n  \"number\": \"558599999999\",\n  \"body\": \"Message\",\n  \"userId\": \"User ID or \\\"\\\"\",\n  \"queueId\": \"Queue ID or \\\"\\\"\",\n  \"sendSignature\": \"Sign message - true/false\",\n  \"closeTicket\": \"Close ticket - true/false\"\n}",
          formDataFields: {
            number: "number: 558599999999",
            body: "body: Message",
            userId: "userId: User ID or \\\"\\\"",
            queueId: "queueId: Queue ID or \\\"\\\"",
            medias: "medias: file",
            sendSignature: "sendSignature: Sign message true/false",
            closeTicket: "closeTicket: Close ticket true/false",
          },
        },
      },
      notifications: {
        title: "Notifications",
        noTickets: "No notifications.",
        tabs: {
          system: "System",
          chat: "Chat",
          internal: "Internal",
        },
      },
      quickMessages: {
        title: "Quick responses",
        subtitle: "Shortcuts for reusable messages in the service flow",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        empty: "No quick responses registered.",
        global: "Global",
        personal: "Personal",
        kpis: {
          total: "Total",
          withMedia: "With media",
          global: "Global",
          personal: "Personal",
        },
        filters: {
          visibility: "Visibility",
          all: "All",
          mine: "Mine",
          shared: "Shared",
        },
        tooltips: {
          edit: "Edit",
          delete: "Delete",
          removeAttachment: "Remove attachment",
        },
        confirmationModal: {
          deleteTitle: "Deletion",
          deleteMessage: "This action is irreversible! Do you wish to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          geral: "Allow editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow viewing",
          allow: "Allow",
          disallow: "Don't allow",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File Name",
          status: "Scope",
          createdBy: "Created by",
          you: "you",
          emptyMessage: "—",
        },
      },
      contactLists: {
        title: "Contact Lists",
        subtitle: "Organize contact bases for campaigns.",
        empty: {
          list: "No lists registered.",
          search: "No list found for the search.",
        },
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
          downloadSample: "Download Sample Spreadsheet",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
          description: "Set a name to identify this base in campaigns and imports.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted",
        },
      },
      contactListItems: {
        title: "Contacts",
        subtitle: "Manage the contacts in this list.",
        searchPlaceholder: "Search",
        empty: {
          list: "No contacts registered in this list.",
          search: "No contact found for the search.",
        },
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
          description: "Fill in the contact details that will be part of this list.",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage: "Do you want to import the contacts from this sheet? ",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted",
        },
        downloadTemplate: "Click here to download sample spreadsheet.",
        whatsappValid: "Valid WhatsApp",
        whatsappInvalid: "Invalid WhatsApp",
      },
      kanban: {
        title: "Kanban",
        subtitle: "Ticket visualization in Kanban format",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Panel",
          tags: "Lanes",
        },
        ticketNumber: "Ticket #",
        viewTicket: "View Ticket",
        startDate: "Start Date",
        endDate: "End Date",
        search: "Search",
        addColumns: "+ Add Columns",
        ticketTagRemoved: "Ticket Tag Removed!",
        ticketTagAdded: "Ticket Tag Added Successfully!",
        ticketMoveError: "Error moving ticket",
        iconChannelError: "Error",
        noTickets: "No tickets",
        emptyStateTags: "No Kanban tags created",
        emptyStateTagsDescription: "Create your first Kanban tag to start organizing tickets",
        createFirstTag: "Create First Tag",
        emptyStateTickets: "No tickets found",
        emptyStateTicketsDescription: "Adjust date filters or create new tickets",
        errorTitle: "Error loading Kanban",
        errorDescription: "An error occurred while fetching data. Please try again.",
        retry: "Try Again",
        card: {
          menu: "More options",
          editSchedule: "Edit schedule",
          deleteSchedule: "Delete schedule",
        },
      },
      campaigns: {
        title: "Campaigns",
        subtitle: "Create and track scheduled blasts to contact lists.",
        empty: {
          list: "No campaigns registered.",
          search: "No campaigns match your search.",
        },
        status: {
          inactive: "Inactive",
          scheduled: "Scheduled",
          inProgress: "In Progress",
          cancelled: "Canceled",
          finished: "Finished",
        },
        common: {
          none: "None",
          notDefined: "Not defined",
          noSchedule: "No schedule",
          notCompleted: "Not completed",
          enabled: "Enabled",
          disabled: "Disabled",
        },
        modal: {
          tabLabels: {
            msg1: "Msg. 1",
            msg2: "Msg. 2",
            msg3: "Msg. 3",
            msg4: "Msg. 4",
            msg5: "Msg. 5",
          },
          helpText: "Use variables like {name}, {number}, {email}, or define custom variables.",
        },
        title: "Campaigns",
        searchPlaceholder: "Search",
        subMenus: {
          list: "List",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Break",
          intervalGapAfter: "Larger interval after",
          undefined: "Not defined",
          messages: "messages",
          laggerTriggerRange: "Larger sending interval",
          addVar: "Add variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
          stopCampaign: "Stop Campaign",
          restartCampaign: "Restart campaign",
          report: "Report",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Scheduled",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully",
          cancel: "Campaign canceled",
          restart: "Campaign restarted",
          deleted: "Record deleted",
        },
        noPermission: "This company does not have permission to access this page! We are redirecting you.",
      },
      campaignReport: {
        title: "Report of",
        subtitle: "Track campaign progress and results",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        cancelled: "Canceled",
        finished: "Finished",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Scheduling",
        conclusion: "Conclusion",
        noPermission: "This company does not have permission to access this page! We are redirecting you.",
        status: "Status:",
        of: "of",
      },
      announcements: {
        title: "Announcements",
        subtitle: "Manage announcements shown to platform users.",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        empty: {
          search: "No announcements match the search.",
          list: "No announcements registered.",
        },
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          subtitle: "Set the title, content, status, and priority for the announcement shown to users.",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully",
          deleted: "Record deleted",
          noPermission: "This company does not have permission to access this page! We are redirecting you.",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
        noPermissionMessage: "This company does not have permission to access this page! We are redirecting you.",
        settingsSaved: "Settings saved",
        intervals: "Intervals",
        intervalDescription: "Set the intervals used for automatic campaign sending.",
        seconds: "seconds",
      },
      campaignsPhrase: {
        title: "Campaigns",
        subtitle: "Manage campaigns triggered by phrases",
        phraseDeleted: "Phrase deleted",
        phraseUpdated: "Phrase successfully updated!",
        phraseCreated: "Phrase successfully created!",
        addCampaign: "Campaign",
        table: {
          name: "Name",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          empty: "No phrase campaigns found",
          emptySearch: "No campaigns match the search.",
        },
        modal: {
          editTitle: "Edit phrase flow campaign",
          newTitle: "New phrase flow campaign",
          nameLabel: "Phrase trigger name",
          flowLabel: "Choose a flow",
          flowPlaceholder: "Choose a flow",
          connectionPlaceholder: "Select a Connection",
          phraseLabel: "Which phrase triggers the flow?",
          matchTypeLabel: "Match type",
          matchTypeExact: "Exact Match",
          matchTypeContains: "Contains word",
          matchTypeTooltip: "Exact: message must exactly match the word. Contains: word can appear anywhere in the message",
          statusLabel: "Status",
          cancelButton: "Cancel",
          saveButton: "Save campaign",
          createButton: "Create campaign",
        },
      },
      queues: {
        title: "Queues",
        subtitle: "Departments to organize and distribute tickets among agents",
        empty: "No queues registered.",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          orderQueue: "Queue sorting (bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add queue",
          edit: "Edit",
          delete: "Delete",
        },
        toasts: {
          success: "Queue saved successfully",
          deleted: "Queue deleted successfully",
          queueDeleted: "Queue deleted successfully!",
          botSaved: "Bot saved successfully",
          clickToSave: "Click save to register changes",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! Services in this queue will still exist but will no longer have a queue assigned.",
        },
      },
      queue: {
        queueData: "Data",
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-only queues",
        withoutQueue: "No queue",
        undefined: "Queue not found",
        errors: {
          loadError: "QUEUESELETSINGLE >>>"
        }
      },
      queueIntegration: {
        title: "Integrations",
        subtitle: "Connect external automated flows like N8N and Typebot",
        empty: "No integrations registered.",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
          edit: "Edit",
          delete: "Delete",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! It will be removed from linked queues and connections",
        },
        toasts: {
          deleted: "Integration deleted successfully!",
        },
        messages: {
          noPermission: "This company does not have permission to access this page! We are redirecting you.",
        },
      },
      users: {
        title: "Users",
        subtitle: "Manage your team's agents, profiles and permissions",
        empty: "No users registered.",
        table: {
          status: "Status",
          avatar: "Avatar",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start",
          endWork: "Work End",
          actions: "Actions",
          ID: "ID",
        },
        profile: {
          admin: "Admin",
          user: "User",
        },
        status: {
          enabled: "Enabled",
          disabled: "Disabled",
        },
        upload: {
          avatar: "Upload Avatar",
        },
        buttons: {
          add: "Add user",
          edit: "Edit",
          delete: "Delete",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Open services from this user will be moved to the queue.",
        },
      },
      companies: {
        title: "Companies",
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConnections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Due Date",
          lastLogin: "Last Login",
          actions: "Actions",
          money: "$",
          yes: "Yes",
          no: "No",
          folderSize: "Folder size",
          totalFiles: "Total files",
          lastUpdate: "Last update",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
        },
        buttons: {
          add: "Add company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets from this user will be moved to the queue.",
        },
        notifications: {
          noPermission: "This company does not have permission to access this page! We are redirecting you.",
        },
      },
      compaies: {
        title: "Companies",
        subtitle: "Manage all companies (tenants) on the platform",
        actions: {
          new: "New company",
        },
        modal: {
          createTitle: "New company",
          editTitle: "Edit company",
          cancel: "Cancel",
          incrementDueDate: "Advance due date by recurrence",
        },
        empty: {
          list: "No companies registered yet.",
          search: "No companies match your search.",
        },
        due: {
          expired: "Expired",
        },
        form: {
          documentLabel: "Tax ID (optional)",
          documentPlaceholder: "000.000.000-00 or 00.000.000/0000-00",
          documentInvalid: "Invalid Tax ID",
          documentDuplicate: "Tax ID already registered",
          documentNotProvided: "Not provided",
          nameRequired: "Name is required",
          emailRequired: "Email is required",
        },
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Due Date",
          lastLogin: "Last Login",
          actions: "Actions",
          money: "$",
          yes: "Yes",
          no: "No",
          folderSize: "Folder size",
          totalFiles: "Total files",
          lastUpdate: "Last update",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
        },
        searchPlaceholder: "Search companies...",
        searchLabel: "Company search field",
        clearSearch: "Clear search",
        buttons: {
          add: "Add company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets from this user will be moved to the queue.",
        },
        notifications: {
          noPermission: "This company does not have permission to access this page! We are redirecting you.",
        },
      },
      plans: {
        title: "Plans",
        subtitle: "Manage the plans available on the platform",
        actions: {
          new: "New plan",
        },
        empty: {
          search: "No plan matches the search.",
          list: "No plan registered.",
        },
        table: {
          actions: "Actions",
        },
        modal: {
          createTitle: "New plan",
          editTitle: "Edit plan",
          cancel: "Cancel",
          billingType: "Billing type",
          billingTypes: {
            single: "Single",
            recurring: "Recurring",
            free: "Free",
          },
          recurrence: "Recurrence",
          recurrences: {
            weekly: "Weekly",
            biweekly: "Biweekly",
            monthly: "Monthly",
            quarterly: "Quarterly",
            semiannual: "Semiannual",
            annual: "Annual",
          },
          resources: "Resources",
          markAll: "Mark all",
          unmarkAll: "Unmark all",
        },
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          campaigns: "Campaigns",
          schedules: "Schedules",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
          public: "Public"
        },
      },
      helps: {
        title: "Help Center",
        subtitle: "Manage YouTube videos shown in the Help Center for end users.",
        thumbnail: "Thumbnail",
        videoPlayerTitle: "YouTube video player",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Clear",
          delete: "Delete",
          save: "Save",
        },
        form: {
          newTitle: "Add new video",
          editTitle: "Edit video",
          titleLabel: "Title",
          titlePlaceholder: "e.g. How to set up WhatsApp",
          linkLabel: "YouTube link",
          linkPlaceholder: "https://www.youtube.com/watch?v=...",
          descriptionLabel: "Description",
          descriptionPlaceholder: "Short summary of what the video teaches",
          invalidLink: "Invalid link. Paste the full YouTube URL.",
        },
        table: {
          title: "Title",
          description: "Description",
          video: "Video",
          actions: "Actions",
        },
        empty: {
          list: "No videos registered yet.",
          search: "No videos match your search.",
        },
        tooltips: {
          title: {
            description: "Short, direct name shown to users on the Help Center card.",
            steps: [
              "Use 5–8 words describing the topic (e.g. \"How to build a flow in FlowBuilder\").",
              "Avoid internal jargon — end users will read this.",
              "The title appears prominently above the description on the card.",
            ],
          },
          link: {
            description: "Full YouTube video URL. The system extracts the video code automatically.",
            steps: [
              "Open the video on YouTube and copy the URL from the address bar.",
              "Accepts: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID and youtube.com/shorts/ID.",
              "If you prefer, just paste the 11-character video ID.",
              "Confirm the video is \"Public\" or \"Unlisted\" — private videos cannot be embedded.",
            ],
          },
          description: {
            description: "Supporting text shown below the title on the help card.",
            steps: [
              "Use 1–2 sentences explaining what the user will learn.",
              "Keep it under ~120 characters — the card truncates after 3 lines.",
              "Optional, but recommended to improve discoverability.",
            ],
          },
        },
      },
      schedules: {
        title: "Schedules",
        subtitleCount: "scheduled messages",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Schedule Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
          addShort: "+ New",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        subtitle: "Organize your contacts with colored labels",
        empty: "No tags registered.",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Kanban",
          color: "Color",
          tickets: "Tag Records",
          contacts: "contacts",
          contact: "contact",
          actions: "Actions",
        },
        kpis: {
          total: "Total tags",
          totalContacts: "Tagged contacts",
          withContacts: "Tags in use",
        },
        tooltips: {
          edit: "Edit",
          delete: "Delete",
          viewContacts: "View contacts",
        },
        buttons: {
          add: "New Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Open",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
          backToKanban: "Back to Kanban",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File List",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "List deleted successfully!",
          deletedAll: "All lists deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "General",
          schedules: "Schedules",
          companies: "Companies",
          plans: "Plans",
          helps: "Help",
          whitelabel: "Whitelabel",
          timezone: "Time Zone",
          smtp: "Email / SMTP",
          meta: "Meta",
        },
        helps: {
          systemCurrency: {
            description: "Sets the currency shown in Kanban cards and all monetary fields of the system.",
            steps: [
              "Select the currency from the dropdown.",
              "The change is synced in real time for all users.",
              "Affects Kanban cards, campaigns and financial reports.",
            ],
          },
          userCreation: {
            description: "Allows new users to register on the platform.",
            steps: [
              "Enable to allow public sign-up at /signup.",
              "Disable to keep full access control.",
            ],
          },
          userRating: {
            description: "Requests a rating from the customer at the end of the ticket.",
            steps: [
              "Enable to send a satisfaction survey when the ticket closes.",
              "The customer rates from 1 to 5.",
              "Data appears in the quality reports.",
            ],
          },
          officeScheduling: {
            description: "Defines where the system reads business hours from.",
            steps: [
              "Disabled: the system does not block service by schedule.",
              "Queue: uses the hours configured in each queue.",
              "Company: uses the company's general business hours.",
              "Connection: uses the hours configured in each WhatsApp connection.",
            ],
          },
          sendGreetingAccepted: {
            description: "Sends a message to the customer when the agent accepts the ticket.",
            steps: [
              "Enable to start the conversation with an automatic greeting.",
              "Customize the text in the field that appears below.",
              "The customer receives it as soon as the agent clicks Accept.",
            ],
          },
          userRandom: {
            description: "Distributes tickets randomly among online agents.",
            steps: [
              "Enable to balance the agent workload.",
              "Only online agents receive distribution.",
            ],
          },
          sendMsgTransfTicket: {
            description: "Sends a message to the customer when the ticket is transferred to another queue.",
            steps: [
              "Enable to inform the customer about the transfer.",
              "Use ${queue.name} to insert the new queue name.",
              "Customize the message in the field below.",
            ],
          },
          acceptCallWhatsapp: {
            description: "Defines whether WhatsApp accepts voice/video calls from customers.",
            steps: [
              "Disable to send an automatic message when a customer calls.",
              "Configure the message in the field below.",
              "Useful when your team doesn't handle phone calls.",
            ],
          },
          sendSignMessage: {
            description: "Lets the agent send a personal signature with messages.",
            steps: [
              "Enable to show the signature button in chat.",
              "Each agent sets their own signature in profile.",
            ],
          },
          sendGreetingMessageOneQueues: {
            description: "Sends greeting even when only one queue is configured.",
            steps: [
              "By default, the greeting is skipped with a single queue.",
              "Enable to always send the queue's greeting message.",
            ],
          },
          sendQueuePosition: {
            description: "Informs the customer about their current position in the queue.",
            steps: [
              "Enable to give transparency about the wait time.",
              "Use ${pos} to include the position in the message.",
              "Customize the text in the field below.",
            ],
          },
          sendFarewellWaitingTicket: {
            description: "Sends a farewell message when a ticket stays in the queue.",
            steps: [
              "Enable to notify the customer about wait time.",
              "The message is configured per queue.",
            ],
          },
          acceptAudioMessageContact: {
            description: "Defines whether the system accepts audio messages from customers.",
            steps: [
              "Disable to block incoming audio messages.",
              "Text and other media continue to work normally.",
            ],
          },
          enableLGPD: {
            description: "Enables data protection controls (GDPR).",
            steps: [
              "Enable to show privacy notices to the customer.",
              "Configure the welcome message and policy link.",
              "Use the options below to obfuscate sensitive data.",
            ],
          },
          requiredTag: {
            description: "Requires at least one tag on the ticket before closing.",
            steps: [
              "Enable to ensure ticket categorization.",
              "Agents won't be able to close tickets without a tag.",
              "Manage tags via \"Tags\" in the side menu.",
            ],
          },
          closeTicketOnTransfer: {
            description: "Closes the current ticket when transferring to another sector.",
            steps: [
              "Enable to create a new ticket in the target sector.",
              "History is preserved in both tickets.",
              "Useful for separating service by department.",
            ],
          },
          showNotificationPending: {
            description: "Shows visual notifications for pending tickets.",
            steps: [
              "Enable to alert agents about waiting tickets.",
              "Notifications appear at the top right.",
            ],
          },
          autoTranslate: {
            description: "Automatically translates messages using AI.",
            steps: [
              "Enable and paste your OpenAI API Key in the field below.",
              "Messages are translated to the agent's language.",
              "Usage costs are billed by OpenAI per tokens consumed.",
            ],
          },
          aiAutoSummary: {
            description: "Generates daily AI summaries of tickets automatically.",
            steps: [
              "Enable to receive summaries of the day's conversations.",
              "Set the time when the summary will be generated.",
              "Covers all open tickets for the day.",
            ],
          },
          sendWelcomeMessage: {
            description: "Sends a welcome message when a new company signs up.",
            steps: [
              "Enable to automate onboarding for new customers.",
              "Customize the template with variables like {name}, {companyName}.",
              "Available variables: {email}, {phone}, {trialDate}.",
            ],
          },
          flowbuilderAI: {
            description: "Enables \"AI Output\" in FlowBuilder blocks.",
            steps: [
              "Enable to use AI when the response time expires.",
              "Paste your OpenAI API Key in the field below.",
              "The AI reads history and takes over the conversation.",
            ],
          },
          greetingAcceptedMessage: {
            description: "Text sent automatically when an agent accepts the ticket.",
            steps: [
              "Write a short, human greeting.",
              "Use it to tell the customer that service has started.",
              "Avoid promising a response time if your operation cannot guarantee it.",
            ],
          },
          transferMessage: {
            description: "Text sent when the ticket is transferred to another queue.",
            steps: [
              "Explain that the service was forwarded to another department.",
              "Use ${queue.name} to show the new queue name.",
              "Keep it clear so the customer does not think the service was abandoned.",
            ],
          },
          AcceptCallWhatsappMessage: {
            description: "Text sent when the customer tries to call on WhatsApp and calls are not accepted.",
            steps: [
              "Explain that service is handled by message.",
              "Ask the customer to write the request in the chat.",
              "Use a polite tone to reduce frustration.",
            ],
          },
          sendQueuePositionMessage: {
            description: "Text that tells the customer their current queue position.",
            steps: [
              "Use ${pos} to insert the current position automatically.",
              "Tell the customer to wait for service.",
              "Avoid exact waiting times if the queue changes a lot.",
            ],
          },
          lgpdMessage: {
            description: "Privacy notice message sent to the contact.",
            steps: [
              "Explain simply that data will be used during service.",
              "Include guidance to accept or continue.",
              "Use wording aligned with your privacy policy.",
            ],
          },
          lgpdDeleteMessage: {
            description: "Obfuscates content of messages deleted by the contact.",
            steps: [
              "Enable to hide messages deleted by the customer.",
              "Disable to keep original content visible.",
              "Recommended for GDPR compliance.",
            ],
          },
          lgpdConsent: {
            description: "Requests explicit consent from the contact about data collection.",
            steps: [
              "Enable to send a consent notice on first contact.",
              "The customer must accept before continuing.",
              "Required in sensitive flows under GDPR.",
            ],
          },
          lgpdHideNumber: {
            description: "Obfuscates the contact's phone number for other users.",
            steps: [
              "Enable to hide the number from unauthorized agents.",
              "Only admins see the full number.",
              "Recommended for privacy compliance.",
            ],
          },
        },
        smtp: {
          title: "Email Settings (SMTP)",
          subtitle: "Configure the SMTP server for sending password recovery emails and notifications.",
          preset: "Email Provider",
          presetCustom: "Custom",
          host: "SMTP Server",
          port: "Port",
          user: "Username / Email",
          userPlaceholder: "you@yourdomain.com",
          password: "Password",
          from: "Sender Email",
          fromHelper: "If empty, the SMTP username will be used",
          fromPlaceholder: "noreply@yourdomain.com",
          secure: "Security",
          secureSslOption: "SSL/TLS (port 465)",
          secureStarttlsOption: "STARTTLS (port 587)",
          sendgridUserLabel: "Username (fixed: apikey)",
          sendgridUserHelper: "SendGrid uses 'apikey' as a fixed username",
          sendgridPasswordLabel: "API Key",
          sendgridFromHelper: "Required: use a sender verified in SendGrid",
          save: "Save Settings",
          testConnection: "Test Connection",
          sendTestTitle: "Send Test Email",
          sendTestSubtitle: "Send a test email to confirm that SMTP is working correctly.",
          testEmailLabel: "Recipient email",
          testEmailPlaceholder: "test@email.com",
          sendTest: "Send Test",
          fillRequired: "Fill in Host, Username and Password.",
          fillTestEmail: "Fill in the recipient email.",
          saveSuccess: "SMTP settings saved successfully!",
          saveError: "Error saving SMTP settings.",
          testError: "Error testing SMTP connection.",
          sendTestError: "Error sending test email.",
          fieldHelps: {
            preset: "Choose your email provider. If it appears in the list, the system fills server, port and security for you. Use Custom when your provider is not listed.",
            host: "Paste the SMTP server address provided by your email provider. Examples: smtp.hostinger.com, smtp.gmail.com, smtp.sendgrid.net.",
            port: "Enter the port indicated by your provider. In most cases use 465 with SSL/TLS or 587 with STARTTLS.",
            user: "Enter the login for the email account that will send messages. Usually this is the full email address, such as contact@yourdomain.com.",
            password: "Enter the SMTP password for the account. In Gmail, Outlook and other providers with two-step verification, you usually need an app password, not the normal login password.",
            sendgridPassword: "Paste the API Key created in SendGrid. Do not use your SendGrid account password.",
            from: "Email address that recipients will see as the sender. If left empty, the system uses the Username / Email above.",
            secure: "Choose the security type that matches the port. Port 465 usually uses SSL/TLS. Port 587 usually uses STARTTLS.",
            testEmail: "Enter your email or a teammate's email to receive the test. This confirms whether sending is working.",
          },
          helps: {
            serverConfig: {
              description: "Configures the SMTP server used to send system emails (password recovery, notifications, invites).",
              steps: [
                "Choose a ready preset (Hostinger, Gmail, SendGrid, Outlook) or \"Custom\".",
                "Fill in Host, Port, Username (account email) and Password (or app password).",
                "Select SSL/TLS (port 465) or STARTTLS (port 587) depending on your provider.",
                "Click \"Test Connection\" to validate before saving.",
                "Save the configuration.",
              ],
            },
            sendTest: {
              description: "Sends a test email using the SMTP settings above to validate the full flow.",
              steps: [
                "Save the SMTP settings first.",
                "Enter a valid recipient email.",
                "Click \"Send Test\" — the email arrives within seconds.",
                "Check the inbox (and spam folder) to confirm delivery.",
              ],
            },
          },
        },
        meta: {
          copy: "Copy",
          copied: "Copied!",
          credentials: {
            title: "Meta App Credentials",
            description: "Connect your App created on Meta for Developers to integrate Facebook Messenger and Instagram Direct.",
            appIdLabel: "Facebook App ID",
            appIdPlaceholder: "Ex.: 123456789012345",
            appIdHelper: "Find it at developers.facebook.com › App › Settings › Basic.",
            appSecretLabel: "Facebook App Secret",
            appSecretPlaceholder: "Ex.: abc123def456...",
            appSecretHelper: "App secret key. Never share or commit it.",
          },
          webhook: {
            title: "Webhook Configuration",
            description: "Use these values when registering the webhook in Meta's panel so messages reach the system.",
            verifyTokenLabel: "Verify Token",
            verifyTokenHelper: "Auto-generated. Paste it in the \"Verify Token\" field of the webhook in Meta.",
            callbackUrlLabel: "Callback URL",
            callbackUrlHelper: "Paste in the \"Callback URL\" field of the webhook in Meta for Developers.",
          },
          fieldHelps: {
            wabaFacebookAppId: "Numeric Meta App ID used for WhatsApp Official API embedded signup.",
            wabaFacebookAppSecret: "Secret key of the Meta App used for WhatsApp Official API. Never share this value.",
            wabaFacebookConfigId: "Facebook Login for Business configuration ID used to open WhatsApp embedded signup.",
            wabaWhatsappBusinessToken: "Permanent system user token with permissions to manage and send messages through WhatsApp Cloud API.",
            socialFacebookAppId: "Numeric Meta App ID used for Facebook Messenger and Instagram Direct.",
            socialFacebookAppSecret: "Secret key of the Meta App used for Facebook Messenger and Instagram Direct. Never share this value.",
            facebookVerifyToken: "Token generated by the system so Meta can confirm that the webhook belongs to this installation.",
            webhookUrl: "URL that must be registered in the Facebook/Instagram Meta App webhook.",
            wabaWebhookUrl: "URL that must be registered in the WhatsApp product webhook of the Meta App.",
            wabaVerifyToken: "Token generated by the system to validate the WhatsApp product webhook in Meta.",
          },
          helps: {
            credentials: {
              description: "Credentials from your App on Meta for Developers — required so Messenger and Instagram messages reach the platform.",
              steps: [
                "Go to developers.facebook.com and create a \"Business\"-type App.",
                "In the App, open Settings › Basic — copy App ID and App Secret.",
                "Paste the values here — they auto-save when you leave the field.",
                "Add the \"Messenger\" and \"Instagram Graph API\" products to the App.",
              ],
            },
            webhook: {
              description: "Webhook that Meta uses to send messages from your channels to the system.",
              steps: [
                "In the Meta App, open Messenger › Settings › Webhooks (same for Instagram).",
                "Click \"Add Callback URL\".",
                "Copy the Callback URL from here and paste in the corresponding field.",
                "Copy the Verify Token from here and paste in Meta's \"Token\" field.",
                "Confirm — Meta will validate the webhook automatically.",
              ],
            },
          },
        },
        settingsConfig: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send greeting upon accepting ticket",
            sendMsgTransfTicket:
              "Send transfer message for department/agent",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            userRandom: "Choose random agent",
            buttons: "Buttons",
            acceptCallWhatsapp: "Inform that calls are not accepted on WhatsApp?",
            sendSignMessage: "Allow agent to choose SEND Signature",
            sendGreetingMessageOneQueues:
              "Send greeting when there is only one queue",
            sendQueuePosition: "Send message with queue position",
            sendFarewellWaitingTicket:
              "Send farewell message in Waiting",
            acceptAudioMessageContact:
              "Accept audio from all contacts?",
            enableLGPD: "Enable GDPR handling",
            requiredTag: "Mandatory tag to close ticket",
            closeTicketOnTransfer: "Close ticket when transferring to another queue",
            DirectTicketsToWallets: "Automatically move client to wallet",
            showNotificationPending: "Show notification for pending tickets",
            autoTranslate: "Automatic Message Translation",
            translateApiKey: "OpenAI API Key (for translation)",
            translateApiKeyHelper: "OpenAI API key for automatic translation. If empty, uses the key from the first configured Prompt.",
            aiAutoSummary: "Automatic Daily AI Summary",
            aiSummaryApiKey: "OpenAI API Key (for AI summary)",
            aiSummaryApiKeyHelper: "Key used only for AI summaries. If empty, uses the translation key or the key from the first configured Prompt.",
            aiAutoSummaryTime: "Daily AI Summary Time",
            aiAutoSummaryTimeHelper: "Time when the automatic summary will be generated for all open tickets.",
            flowbuilderAISectionTitle: "FlowBuilder AI Output",
            flowbuilderAISectionDescription: "When enabled, \"AI Output\" in FlowBuilder blocks uses GPT to read the conversation history and automatically take over the service when the timer expires.",
            flowbuilderAI: "Enable AI Output in FlowBuilder",
            flowbuilderAIApiKey: "OpenAI API Key (AI Output)",
            flowbuilderAIApiKeyHelper: "OpenAI API key used by AI Output in FlowBuilder blocks.",
            sendWelcomeMessage: "Welcome message on signup",
            welcomeMessageTemplate: "Welcome message template",
            welcomeMessageHelper: "Use variables: {name}, {companyName}, {email}, {phone}, {trialDate}. If empty, uses the default template.",
          },
          customMessages: {
            sendQueuePositionMessage: "Queue position message",
            AcceptCallWhatsappMessage: "Message to inform calls are not accepted",
            greetingAcceptedMessage: "Greeting message upon accepting ticket",
            transferMessage: "Transfer message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "GDPR",
            welcome: "Welcome message (GDPR)",
            linkLGPD: "Privacy policy link",
            obfuscateMessageDelete: "Hide deleted message",
            alwaysConsent: "Always request consent",
            obfuscatePhoneUser: "Hide phone number for users",
            enabled: "Enabled",
            disabled: "Disabled",
          },
        },
        toasts: {
          schedulesSavedSuccess: "Schedules updated successfully.",
          operationUpdatedSuccess: "Operation updated successfully.",
          recordsLoadError: "Unable to load records list",
          operationSuccess: "Operation performed successfully!",
          operationError: "Unable to perform operation. Check if a record with the same name already exists or if all fields are filled correctly",
          operationDeleteError: "Unable to perform operation",
          imageUploadProgress: "Image is {{progress}}% uploaded...",
          imageUploadError: "There was a problem uploading the image.",
          companyOperationError: "Unable to perform operation. Check if a company with the same name already exists or if all fields are filled correctly",
          planOperationError: "Unable to perform operation. Check if a plan with the same name already exists or if all fields are filled correctly",
          helpOperationError: "Unable to perform operation. Check if a help with the same name already exists or if all fields are filled correctly",
        },
        whitelabel: {
          subtitle: "Customize the system brand — colors, name, logos and favicon — shown across the application.",
          primaryColorLight: "Light Mode Primary Color",
          primaryColorDark: "Dark Mode Primary Color",
          sidebarTextColorLight: "Sidebar text and icon color in light mode",
          sidebarTextColorDark: "Sidebar text and icon color in dark mode",
          systemName: "System Name",
          systemNamePlaceholder: "e.g. ChatIA",
          lightLogo: "Light Logo",
          darkLogo: "Dark Logo",
          sidebarLightLogo: "Sidebar logo in light mode",
          sidebarDarkLogo: "Sidebar logo in dark mode",
          loginLightLogo: "Login logo in light mode",
          loginDarkLogo: "Login logo in dark mode",
          sidebarIconLight: "Closed sidebar icon in light mode",
          sidebarIconDark: "Closed sidebar icon in dark mode",
          favicon: "Favicon",
          sections: {
            identity: "Visual Identity",
            identitySubtitle: "Define colors and the name shown to users.",
            logos: "System Logos",
            logosSubtitle: "Images used on login, sidebar and browser tabs.",
          },
          actions: {
            upload: "Upload image",
            replace: "Replace",
            remove: "Remove",
            pickColor: "Pick color",
          },
          languages: {
            title: "Languages",
            subtitle: "Set the company's default language and which languages users are allowed to choose.",
            defaultLabel: "Default language",
            availableLabel: "Available languages",
            defaultBadge: "Default",
            selectedCount_one: "{{count}} language selected",
            selectedCount_other: "{{count}} languages selected",
          },
          whatsappButton: {
            title: "WhatsApp button",
            subtitle: "Control the contact button shown on signup and in trial mode.",
            enabledLabel: "Show buttons",
            enabledTitle: "Buttons active",
            enabledHint: "When disabled, removes the button from public screens and trial mode.",
            phoneLabel: "WhatsApp phone",
          },
          previews: {
            light: "Preview (light mode)",
            dark: "Preview (dark mode)",
            loginLight: "Login preview (light mode)",
            loginDark: "Login preview (dark mode)",
            sidebarIconLight: "Sidebar icon preview (light mode)",
            sidebarIconDark: "Sidebar icon preview (dark mode)",
            favicon: "Preview (favicon)",
            empty: "No image uploaded — using system default.",
          },
          helps: {
            primaryColorLight: {
              description: "Accent color used when the system is in light theme (buttons, links, primary icons).",
              steps: [
                "Click the field to open the color picker.",
                "Use colors with good contrast on white background (dark enough for legible text).",
                "The change applies immediately for all users.",
                "Paste a valid HEX (e.g. #1976d2) if you already have the brand color.",
              ],
            },
            primaryColorDark: {
              description: "Accent color used when the system is in dark theme.",
              steps: [
                "Click the field to open the color picker.",
                "Prefer light enough colors to contrast with dark backgrounds.",
                "Doesn't have to match the light mode — adapt for legibility.",
                "Paste a valid HEX (e.g. #4fc3f7) to skip the picker.",
              ],
            },
            sidebarTextColorLight: {
              description: "Single color applied to sidebar texts and icons when the system is in light mode.",
              steps: [
                "Click the field to open the color picker.",
                "Use a color with good contrast over the light sidebar primary color.",
                "The change is applied immediately to the sidebar.",
                "Affects sidebar texts, icons, dividers and collapse button in light mode.",
              ],
            },
            sidebarTextColorDark: {
              description: "Single color applied to sidebar texts and icons when the system is in dark mode.",
              steps: [
                "Click the field to open the color picker.",
                "Use a color with good contrast over the dark sidebar primary color.",
                "The change is applied immediately to the sidebar.",
                "Affects sidebar texts, icons, dividers and collapse button in dark mode.",
              ],
            },
            systemName: {
              description: "Product name displayed in several places (browser tab title, e-mails, login, sidebar).",
              steps: [
                "Use the commercial name — ~20 characters max recommended.",
                "Saved automatically when you leave the field.",
                "Appears in the page <title> (browser tab).",
                "Leave blank to use \"Multi100\" as default.",
              ],
            },
            lightLogo: {
              description: "Logo shown at the top of the sidebar when the system is in light theme.",
              steps: [
                "Use PNG or SVG with transparent background.",
                "Recommended resolution: up to 400×120 px.",
                "This logo does not change the login screen.",
                "Click the remove icon to revert to the default logo.",
              ],
            },
            darkLogo: {
              description: "Logo shown at the top of the sidebar when the system is in dark theme.",
              steps: [
                "Use a light version of the logo, with good contrast on dark background.",
                "PNG or SVG with transparent background.",
                "Recommended resolution: up to 400×120 px.",
                "This logo does not change the login screen.",
              ],
            },
            loginLightLogo: {
              description: "Logo shown on login, signup and password recovery screens in light mode.",
              steps: [
                "Use a version optimized for light backgrounds.",
                "This logo is independent from the sidebar logo.",
                "If empty, the system uses the light sidebar logo as fallback.",
              ],
            },
            loginDarkLogo: {
              description: "Logo shown on login, signup and password recovery screens in dark mode.",
              steps: [
                "Use a version optimized for dark backgrounds.",
                "This logo is independent from the sidebar logo.",
                "If empty, the system uses the dark sidebar logo as fallback.",
              ],
            },
            sidebarIconLight: {
              description: "Icon shown when the sidebar is collapsed in light mode.",
              steps: [
                "Use a square image, preferably PNG or SVG.",
                "On hover, the icon is replaced by the button that opens the sidebar.",
                "If empty, the system uses the favicon as fallback.",
              ],
            },
            sidebarIconDark: {
              description: "Icon shown when the sidebar is collapsed in dark mode.",
              steps: [
                "Use a version with good contrast for dark backgrounds.",
                "When the mouse leaves, the button changes back to the icon.",
                "If empty, the system uses the favicon as fallback.",
              ],
            },
            favicon: {
              description: "Icon shown in the browser tab and shortcuts.",
              steps: [
                "Use a square PNG or ICO (32×32, 48×48 or 64×64 px).",
                "Keep the design simple — it shows very small in the tab.",
                "May take a few minutes to update in the browser (cache).",
                "Force refresh with Ctrl+F5 if you don't see the change.",
              ],
            },
            defaultLanguage: {
              description: "Language shown on public screens (login/signup) and used as default for every user of the company who hasn't picked one manually.",
              steps: [
                "Pick the default language from the dropdown.",
                "When changed, users who were still on the previous default are automatically migrated to the new one.",
                "Users who manually picked a language from the topbar selector are NOT affected.",
                "The default language is always kept as available.",
              ],
            },
            availableLanguages: {
              description: "Languages users can select from the flag button at the top.",
              steps: [
                "Check the languages you want to enable for your team.",
                "Unchecking a language removes it immediately from every online user's selector.",
                "The default language is always available (you can't uncheck it).",
                "Changes are reflected in real time — no reload needed.",
              ],
            },
          },
        },
        timezone: {
          companyTimezone: {
            title: "Company Time Zone",
            selectLabel: "Select time zone",
            customHelperText: "Custom time zone for this company",
            inheritedHelperText: "Using system default time zone",
          },
          defaultTimezone: {
            title: "System Default Time Zone",
            selectLabel: "Select default time zone",
            helperText: "This time zone will be used by default for all companies that don't have a custom time zone",
          },
          buttons: {
            save: "Save",
            useDefault: "Use Default",
            saveDefault: "Save Default",
          },
          preview: {
            currentTime: "Current Time",
            defaultTime: "Default Time",
          },
          status: {
            custom: "Custom",
            inherited: "Inherited",
          },
          errors: {
            fetchAvailableTimezones: "Error loading available time zones",
            fetchCompanyTimezone: "Error loading company time zone",
            updateDefaultTimezone: "Error updating default time zone",
            updateCompanyTimezone: "Error updating company time zone",
          },
          success: {
            defaultTimezoneUpdated: "Default time zone updated successfully",
            companyTimezoneUpdated: "Company time zone updated successfully",
            companyTimezoneReset: "Company time zone reset successfully",
          },
          helps: {
            companyTimezone: {
              description: "Sets the time zone used for all dates and times in the company (notifications, schedules, reports, business hours).",
              steps: [
                "Select the desired time zone from the dropdown.",
                "Click \"Save\" to apply — affects the whole company.",
                "Click \"Use Default\" to revert to the time zone set by the super admin.",
                "The preview on the right shows the current time in the selected zone.",
              ],
            },
            defaultTimezone: {
              description: "Time zone used by default for all companies that haven't set their own.",
              steps: [
                "Set the global default time zone here.",
                "Companies without a custom zone inherit this value.",
                "Changes here only affect companies that haven't customized their own zone.",
                "Only super admins can change this field.",
              ],
            },
            companyTimezoneField: {
              description: "Field where you choose this company's time zone.",
              steps: [
                "Search by country, city or time zone name.",
                "Choose the zone where the company operates.",
                "Save to apply it to schedules, reports and business hours.",
              ],
            },
            defaultTimezoneField: {
              description: "Field where the super admin chooses the system default time zone.",
              steps: [
                "Use the zone of most companies served by the platform.",
                "Companies without their own zone will use this value automatically.",
                "Save to apply it as the global default.",
              ],
            },
          },
        },
        chatBotType: {
          text: "Text",
        },
        modals: {
          deleteTitle: "Delete Record",
          deleteConfirmation: "Do you really want to delete this record?",
        },
        managers: {
          common: {
            yes: "Yes",
            no: "No",
          },
          companies: {
            recurrence: "Recurrence",
          },
          plans: {
            queues: "Queues",
            value: "Value",
            whatsapp: "WhatsApp",
            facebook: "Facebook",
            instagram: "Instagram",
            internalChat: "Internal Chat",
            externalAPI: "External API",
            kanban: "Kanban",
            talkAI: "Prompts",
            officialAPI: "Official API",
            integrations: "Integrations",
          },
          helps: {
            title: "Title",
            video: "Video",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          draft: "Draft:",
          you: "You",
          contact: "Contact",
          document: "Document",
          photo: "Photo",
          image: "Image",
          video: "Video",
          group: "Group",
          options: "Options",
          aiSummaries: "AI Summaries",
          chatbotActive: "Chatbot active",
          chatbotInactive: "Chatbot inactive",
          enableChatbot: "Enable Chatbot",
          disableChatbot: "Disable Chatbot",
          months: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
          dateOf: "",
          dialogRatingTitle:
            "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable integration",
            disableIntegration: "Disable integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
            enableTranslate: "Enable auto-translate for this contact",
            disableTranslate: "Disable auto-translate for this contact",
            translateEnabled: "Translation enabled",
            translateDisabled: "Translation disabled",
            kanban: "Kanban",
            tags: "Tags",
            aiSummaries: "AI Summaries",
            options: "Options",
            chatbotActive: "Chatbot active",
            chatbotInactive: "Chatbot inactive",
            enableChatbot: "Enable Chatbot",
            disableChatbot: "Disable Chatbot",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Type a message or press / for quick responses",
        placeholderOpen:
          "Type a message or press / for quick responses",
        placeholderClosed:
          "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        privateMessage: "Private Message",
        you: "You",
        contact: "Contact",
        videoFallback: "Video",
        format: {
          bold: "Bold",
          italic: "Italic",
          strikethrough: "Strikethrough",
          code: "Code",
          numberedList: "Numbered list",
          bulletList: "Bullet list",
          quote: "Quote",
        },
        aiSuggestion: {
          tooltip: "AI Suggestion",
          configTitle: "Configure AI Suggestions",
          promptLabel: "Custom prompt",
          promptPlaceholder: "E.g.: You are a sales agent specialized in software. Always suggest scheduling a demo...",
          promptHelper: "Instruct the AI on how to generate suggestions. E.g.: agent profile, tone, products, business rules.",
          save: "Save",
          saving: "Saving...",
        },
        quickReplies: {
          header: "Quick replies",
          searchPlaceholder: "Search by shortcut or message...",
          empty: "No reply found",
          useReply: "Use reply",
        },
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
          block: "Block",
          unblock: "Unblock",
          blockContact: "Block contact",
          unblockContact: "Unblock contact",
        },
        tabs: {
          data: "Data",
          followUp: "Follow-up",
          favorites: "Favorites",
        },
        none: "None",
        noFavoriteMessages: "No favorite messages",
        qualification: "Qualification",
        toasts: {
          contactBlocked: "Contact blocked",
          contactUnblocked: "Contact unblocked",
        },
        confirmationModal: {
          blockMessage: "Do you really want to block this contact? You will no longer receive messages from them.",
          unblockMessage: "Do you really want to unblock this contact? You will be able to start receiving messages from them.",
        },
        extraInfo: "Other information",
      },
      messageVariablesPicker: {
        label: "Available variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          email: "E-mail",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Department",
          connection: "Connection",
        },
        templates: {
          firstName: { label: "First name", description: "Contact's first name" },
          name: { label: "Full name", description: "Contact's full name" },
          userName: { label: "Agent", description: "Agent's name" },
          ticketId: { label: "Ticket ID", description: "Ticket number" },
          greeting: { label: "Greeting", description: "Good morning / Good afternoon / Good evening" },
          hour: { label: "Hour", description: "Current hour" },
          date: { label: "Date", description: "Current date" },
          dateTime: { label: "Date and time", description: "Current date and time" },
          queue: { label: "Queue", description: "Ticket queue name" },
          connection: { label: "Connection", description: "WhatsApp connection name" },
          protocol: { label: "Protocol", description: "Protocol number" },
          companyName: { label: "Company", description: "Company name" },
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Close without farewell",
        acceptAudioMessage: "Accept audios from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to record here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact ",
          message:
            "Attention! All messages related to the ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      emoji: {
        search: "Search",
        notfound: "No emoji found",
        categories: {
          search: "Results",
          recent: "Recent",
          smileys: "Smileys & Emotion",
          people: "People",
          nature: "Animals & Nature",
          foods: "Food & Drink",
          activity: "Activity",
          places: "Travel & Places",
          objects: "Objects",
          symbols: "Symbols",
          flags: "Flags",
          custom: "Custom",
        },
      },
      messageInput: {
        variables: "Variables",
        aiSuggestions: "AI Suggestions",
        selectLanguage: "Select language",
        placeholderCaption: "Add a caption...",
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send link for video conference",
          language: "Contact language — defines which language the message will be translated to",
        },
        type: {
          title: "Attach",
          imageVideo: "Photos and videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video call",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        talkTo: "Talk To",
        react: "React",
        favorite: "Favorite",
        unfavorite: "Unfavorite",
        copy: "Copy",
        erase: "Erase",
        aiGenerationFailed: "No suggestion generated. Check if the API key is configured.",
        saveToContact: "Save to contact",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Due Date",
          action: "Action",
        },
      },
      userStatus: {
        online: "Online",
        offline: "Offline",
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "There must be at least one default WhatsApp.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check the connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session was not initialized. Check the connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not verify WhatsApp contact. Check the connections page",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid WhatsApp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check the connections page.",
        ERR_INVALID_CREDENTIALS:
          "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check the connections page.",
        ERR_DELETE_WAPP_MSG: "Could not delete the WhatsApp message.",
        ERR_OTHER_OPEN_TICKET: "There is already an open ticket for this contact.",
        ERR_TICKET_ALREADY_ACCEPTED: "This ticket has already been accepted by another agent.",
        ERR_SESSION_EXPIRED: "Session expired. Please log in.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by the administrator.",
        ERR_NO_PERMISSION: "You do not have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error creating message in the database.",
        ERR_CREATING_TICKET: "Error creating ticket in the database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message from WhatsApp; it may be too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use; choose another.",
        ERR_WAPP_GREETING_REQUIRED:
          "The greeting message is mandatory when there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
        ERR_USER_EMAIL_ALREADY_EXISTS: "This email is already in use. Please use a different email.",
        ERR_COMPANY_INVALID_NAME: "Organization name must be at least 2 characters.",
        ERR_COMPANY_DUPLICATE_FIELD: "An account with these details already exists.",
        ERR_COMPANY_CREATION_FAILED: "Error creating the company. Please try again.",
        ERR_GENERIC_ERROR: "An error occurred!",
      },
      flowBuilderConfig: {
        title: "Design your flow",
        actions: {
          import: "Import",
          export: "Export",
          save: "Save"
        },
        messages: {
          flowStart: "Flow start",
          interval: "Interval {{seconds}} sec.",
          intervalFormatted: "Interval {{value}} {{unit}}",
          businessHoursLabel: "Business Hours",
          units: {
            seconds: "sec.",
            minutes: "min.",
            hours: "h",
            days: "days",
          },
          rememberSave: "Don't forget to save your flow!",
          flowSaved: "Flow saved successfully"
        },
        nodes: {
          start: "Start",
          content: "Content",
          menu: "Menu",
          optionFormat: "[{{number}}] {{value}}",
          randomizer: "Randomizer",
          interval: "Interval",
          ticket: "Ticket",
          typebot: "TypeBot",
          openai: "OpenAI",
          question: "Question",
          image: "Image",
          video: "Video",
          audioNode: {
            title: "Audio",
            recordedLive: "Live recorded",
            audioSent: "Audio sent",
            browserNotSupported: "your browser does not support HTML5"
          },
          kanbanPhase: "Kanban Phase",
          addTag: "Add Tag",
          noTag: "No tag",
          noResponse: "No response",
        },
        nodeDescriptions: {
          startFlow: "This block marks the start of your flow!"
        },
        edges: {
          edgeWithoutOnDelete: "Edge without onDelete configured:",
          errorDeletingEdge: "Error deleting edge:",
          removeEdgeTooltip: "Remove connection"
        },
        units: {
          seconds: "seconds"
        },
        validation: {
          tooShort: "Too short!",
          tooLong: "Too long!",
          enterName: "Enter a name!",
          enterMessage: "Enter a message!",
          required: "Required",
          describeAiTraining: "Describe the training for Artificial Intelligence",
          invalidModel: "Invalid model",
          informModel: "Enter the model",
          minTokens: "Minimum 10 tokens",
          maxTokens: "Maximum 4096 tokens",
          informMaxTokens: "Enter the maximum number of tokens",
          minZero: "Minimum 0",
          maxOne: "Maximum 1",
          informTemperature: "Enter the temperature",
          informApiKey: "Enter the API Key",
          minOneMessage: "Minimum 1 message",
          maxFiftyMessages: "Maximum 50 messages",
          informMaxMessages: "Enter the maximum number of messages",
          informVoiceMode: "Enter the voice mode"
        },
        buttons: {
          add: "Add",
          save: "Save",
          edit: "Edit"
        },
        modals: {
          condition: {
            addTitle: "Add condition to flow",
            editTitle: "Edit condition",
            fieldLabel: "Condition field (Enter only 1 key)",
            validationRule: "Validation rule",
            conditionValue: "Condition value to be analyzed"
          },
          ticket: {
            addQueueError: "Add a queue",
            addTitle: "Add a queue to the flow",
            editTitle: "Edit queue",
            selectConnection: "Select a queue"
          },
          randomizer: {
            addIntervalError: "Add the interval value",
            maxTimeError: "Maximum time reached 120 seconds",
            addTitle: "Add a randomizer to the flow",
            editTitle: "Edit randomizer"
          },
          openai: {
            addTitle: "Add OpenAI/Gemini to flow",
            editTitle: "Edit OpenAI/Gemini of flow"
          },
          question: {
            addTitle: "Add Question to flow",
            editTitle: "Edit Question",
            createTitle: "Create Question in flow",
            messageLabel: "Message",
            saveAnswer: "Save answer"
          }
        },
        models: {
          "gpt-4.1": "GPT 4.1",
          "gpt-4.1-mini": "GPT 4.1 Mini",
          "gpt-4.1-nano": "GPT 4.1 Nano",
          "gpt-4o": "GPT 4o",
          "gpt-4o-mini": "GPT 4o Mini",
          "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legacy)",
          "gemini-2.5-pro": "Gemini 2.5 Pro",
          "gemini-2.5-flash": "Gemini 2.5 Flash",
          "gemini-2.0-flash": "Gemini 2.0 Flash",
          "gemini-2.0-pro": "Gemini 2.0 Pro",
        },
        voice: {
          text: "Text",
          francisca: "Francisca",
          antonio: "Antonio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fabio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Leticia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valerio",
          yara: "Yara"
        }
      },
      flowBuilderModals: {
        textModal: {
          titleAdd: "Add message to flow",
          titleEdit: "Edit flow message",
          buttonAdd: "Add",
          buttonSave: "Save",
          fields: {
            message: "Message"
          },
          validation: {
            tooShort: "Too short!",
            tooLong: "Too long!",
            required: "Enter a name!",
            messageRequired: "Enter a message!"
          }
        },
        intervalModal: {
          titleAdd: "Add an interval to the flow",
          titleEdit: "Edit interval",
          buttonAdd: "Add",
          buttonEdit: "Edit",
          fields: {
            interval: "Interval",
            timeInSeconds: "Time in seconds",
            timeValue: "Time",
            unit: "Unit",
            unitSeconds: "Seconds",
            unitMinutes: "Minutes",
            unitHours: "Hours",
            unitDays: "Days",
            businessHours: "Business hours",
            businessHoursHelp: "The message will only be sent during configured business hours",
            startTime: "Start",
            endTime: "End",
            daysOfWeek: "Days of week",
            daySun: "Sun",
            dayMon: "Mon",
            dayTue: "Tue",
            dayWed: "Wed",
            dayThu: "Thu",
            dayFri: "Fri",
            daySat: "Sat",
          },
          validation: {
            addValue: "Add the interval value",
            maxTime: "Maximum value reached for this unit",
            maxSeconds: "Maximum 120 seconds",
            maxMinutes: "Maximum 120 minutes",
            maxHours: "Maximum 72 hours",
            maxDays: "Maximum 30 days",
          },
          aiTimeout: {
            title: "AI output (time until AI takes over)",
            label: "Time in seconds (0 = disabled)",
            helperText: "If the client does not respond within {{seconds}}s, AI takes over the conversation (purple output)"
          }
        },
        typebotModal: {
          titleAdd: "Add Typebot to flow",
          titleEdit: "Edit Typebot",
          buttonAdd: "Add",
          buttonEdit: "Save",
          fields: {
            url: "Typebot URL",
            slug: "Bot Slug (identifier)",
            expires: "Session expiration (minutes)",
            delay: "Delay between messages (ms)",
            keywordFinish: "Keyword to finish",
            keywordRestart: "Keyword to restart",
            unknownMessage: "Invalid option message",
            restartMessage: "Restart message",
          },
          instructions: {
            title: "How to set up Typebot (step by step)",
            step1: "Have a Typebot instance running (self-hosted or Typebot Cloud at typebot.io). Note the base URL, e.g.: https://typebot.yourcompany.com",
            step2: "In the Typebot dashboard, create or open the bot you want to use. The Slug is the bot identifier in the URL — e.g., if the bot URL is typebot.io/my-bot, the slug is \"my-bot\".",
            step3: "In the \"Typebot URL\" field above, paste your instance's base URL (without trailing slash). In the \"Slug\" field, paste the bot identifier.",
            step4: "Set the session expiration (in minutes). After this time without interaction, a new conversation will start. Value 0 = never expires.",
            step5: "Optionally, set keywords to finish (e.g., \"exit\") or restart (e.g., \"restart\") the bot conversation.",
            variablesTitle: "Variables available in Typebot:",
            varNumber: "Contact's WhatsApp number",
            varPushName: "Contact's WhatsApp name",
            varRemoteJid: "Contact's full ID (JID)",
            jsonTitle: "Advanced commands (JSON):",
            jsonDesc: "In Typebot, send a message starting with # to execute actions in ChatIA:",
            jsonStop: "Stops the bot and transfers to an agent",
            jsonQueue: "Transfers to queue ID 1",
            jsonUser: "Transfers to queue 1, agent 5",
            tip: "Tip: Typebot supports text, images, audio, video, and choice buttons. All are automatically sent via WhatsApp.",
          },
        },
        menuModal: {
          titleAdd: "Add menu to flow",
          titleEdit: "Edit menu",
          buttonAdd: "Add",
          buttonSave: "Save",
          fields: {
            explanationMessage: "Menu explanation message",
            addOption: "Add Option",
            typeOption: "Type {{number}}",
            optionPlaceholder: "Type option"
          },
          invalidOption: {
            title: "Invalid option",
            messageLabel: "Invalid option message",
            placeholder: "E.g.: Invalid option. Please choose one of the options below:",
            helperText: "If filled, when the client sends something outside the options, this message will be sent and the menu will be reshown."
          },
          timeout: {
            title: "Timeout (no response)",
            label: "Time in seconds (0 = disabled)",
            helperText: "If the client doesn't respond within {{seconds}}s, the flow follows the timeout path (orange exit)"
          },
          aiTimeout: {
            title: "AI output (time until AI takes over)",
            label: "Time in seconds (0 = disabled)",
            helperText: "If the client does not respond within {{seconds}}s, AI takes over the conversation (purple output)"
          }
        },
        singleBlockModal: {
          titleAdd: "Add content to flow",
          titleEdit: "Edit content",
          buttonAdd: "Add",
          buttonSave: "Save",
          elements: {
            text: "Text",
            interval: "Interval",
            image: "Image",
            audio: "Audio",
            video: "Video",
            document: "Document"
          },
          fields: {
            message: "Message",
            timeInSeconds: "Time in seconds",
            sendAsRecordedAudio: "Send as recorded audio",
            noFileSelected: "No file selected"
          },
          buttons: {
            sendImage: "Send image",
            sendAudio: "Send audio",
            sendVideo: "Send video",
            sendDocument: "Send Document"
          },
          validation: {
            emptyMessageFields: "Empty message fields!",
            intervalValidation: "Interval cannot be 0 or greater than 120!",
            fileTooLarge2MB: "File too large! 2MB maximum",
            fileTooLarge5MB: "File too large! 5MB maximum",
            fileTooLarge20MB: "File too large! 20MB maximum",
            fileTooLarge15MB: "File too large! 15MB maximum",
            deleteEmptyCards: "Delete empty cards or send pending files.",
            browserNotSupported: "your browser does not support HTML5",
            onlyMp4Videos: "ATTENTION! Only MP4 videos!",
            uploadError: "Error processing the file"
          },
          messages: {
            contentAddedSuccess: "Content added successfully!",
            uploadingFiles: "Uploading files and creating content...",
            variables: "Variables"
          },
          timeout: {
            title: "Timeout (no response)",
            label: "Time in seconds (0 = disabled)",
            helperText: "If the client does not respond within {{seconds}}s, the flow follows the timeout path (yellow output)"
          },
          aiTimeout: {
            title: "AI output (time until AI takes over)",
            label: "Time in seconds (0 = disabled)",
            helperText: "If the client does not respond within {{seconds}}s, AI takes over the conversation (purple output)"
          },
          audioRecorder: {
            or: "or",
            recordAudio: "Record audio",
            recording: "Recording",
            paused: "Paused",
            recordingCompleted: "Recording completed - {{time}}",
            discard: "Discard",
            useThisAudio: "Use this audio",
            cancel: "Cancel",
            pause: "Pause",
            resume: "Resume",
            finish: "Finish",
            pausedHint: "Listen to the preview, resume or finish the recording",
            recordingHint: "Pause or finish the recording",
            microphoneError: "Could not access the microphone. Check your browser permissions."
          }
        },
        randomizerModal: {
          titleAdd: "Add a randomizer to the flow",
          titleEdit: "Edit randomizer",
          title: "Output distribution",
          sliderLabel: "Randomizer percentage",
          outputsTitle: "How it works",
          outputsHint: "The first percentage follows the first output; the remainder follows the second output.",
          buttonAdd: "Add",
          buttonEdit: "Edit"
        },
        ticketModal: {
          titleAdd: "Add a queue to the flow",
          titleEdit: "Edit queue",
          buttonAdd: "Add",
          buttonEdit: "Edit",
          fields: {
            selectConnection: "Select a Connection"
          },
          validation: {
            addQueue: "Add a queue"
          }
        },
        openaiModal: {
          titleAdd: "Add OpenAI/Gemini to flow",
          titleEdit: "Edit OpenAI/Gemini of flow",
          buttonAdd: "Add",
          buttonSave: "Save",
          models: {
            "gpt-4.1": "GPT 4.1",
            "gpt-4.1-mini": "GPT 4.1 Mini",
            "gpt-4.1-nano": "GPT 4.1 Nano",
            "gpt-4o": "GPT 4o",
            "gpt-4o-mini": "GPT 4o Mini",
            "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legacy)",
            "gemini-2.5-pro": "Gemini 2.5 Pro",
            "gemini-2.5-flash": "Gemini 2.5 Flash",
            "gemini-2.0-flash": "Gemini 2.0 Flash",
            "gemini-2.0-pro": "Gemini 2.0 Pro",
          },
          voices: {
            text: "Text",
            francisca: "Francisca",
            antonio: "Antonio",
            brenda: "Brenda",
            donato: "Donato",
            elza: "Elza",
            fabio: "Fabio",
            giovanna: "Giovanna",
            humberto: "Humberto",
            julio: "Julio",
            leila: "Leila",
            leticia: "Leticia",
            manuela: "Manuela",
            nicolau: "Nicolau",
            valerio: "Valerio",
            yara: "Yara"
          },
          validation: {
            tooShort: "Too short!",
            tooLong: "Too long!",
            required: "Required",
            promptRequired: "Describe the training for Artificial Intelligence",
            invalidModel: "Invalid model",
            minTokens: "Minimum 10 tokens",
            maxTokens: "Maximum 4096 tokens",
            tokensRequired: "Inform the maximum number of tokens",
            temperatureRequired: "Inform the temperature",
            temperatureMin: "Minimum 0",
            temperatureMax: "Maximum 1",
            apiKeyRequired: "Inform the API Key",
            messagesMin: "Minimum 1 message",
            messagesMax: "Maximum 50 messages",
            messagesRequired: "Inform the maximum number of messages",
            voiceRequired: "Inform the voice mode"
          },
          instructions: {
            title: "How to set up OpenAI (step by step)",
            step1: "Go to platform.openai.com and create an account. In the sidebar, go to \"API Keys\" and click \"Create new secret key\". Copy the generated key.",
            step2: "Paste the key in the \"API Key\" field above. This key is secret — do not share it with anyone.",
            step3: "In the \"Prompt\" field, write the AI behavior instructions. Example: \"You are a virtual assistant for company X. Respond politely and objectively about our products and services.\"",
            step4: "Choose the model: GPT-4o Mini is the best value for customer service. GPT-4.1 is smarter but costs more. GPT-3.5 Turbo is the cheapest.",
            step5: "Temperature controls creativity (0 = exact answers, 1 = creative answers). For customer service, use between 0.3 and 0.7. Max Tokens limits the response length.",
            promptTipTitle: "Tips for a good prompt:",
            promptTip: "Be specific about the AI's role, tone of voice, company products/services, and what it should NOT do. The more detailed the prompt, the better the responses.",
            tip: "Tip: The \"Max Messages\" field defines how many context messages the AI remembers. Higher values = more contextual answers but cost more tokens.",
          },
        },
        geminiModal: {
          instructions: {
            title: "How to set up Gemini AI (step by step)",
            step1: "Go to aistudio.google.com and sign in with your Google account. Click \"Get API Key\" then \"Create API key\". Copy the generated key.",
            step2: "Paste the key in the \"API Key (Google AI)\" field above. This key is secret — do not share it with anyone.",
            step3: "In the \"Prompt\" field, write the AI behavior instructions. Example: \"You are a virtual assistant for company X. Respond politely and objectively.\"",
            step4: "Choose the model: Gemini 2.5 Flash is the best value. Gemini 2.5 Pro is smarter but slower. Gemini 2.0 Flash is the fastest.",
            step5: "Temperature controls creativity (0 = exact answers, 1 = creative answers). For customer service, use between 0.3 and 0.7.",
            promptTipTitle: "Tips for a good prompt:",
            promptTip: "Be specific about the AI's role, tone of voice, products/services, and what it should NOT do. The more detailed, the better the responses.",
            tip: "Tip: Google's Gemini has a generous free tier. Ideal for testing without costs.",
          },
        },
        questionModal: {
          titleAdd: "Add Question to flow",
          titleEdit: "Edit Question of flow",
          titleCreate: "Create Question in flow",
          buttonAdd: "Add",
          buttonSave: "Save",
          fields: {
            message: "Message",
            saveAnswer: "Save answer"
          },
          timeout: {
            title: "Timeout (no response)",
            label: "Time in seconds (0 = disabled)",
            helperText: "If the customer does not respond in {{seconds}}s, the flow follows the timeout path (yellow output)"
          },
          aiTimeout: {
            title: "AI output (time before AI takes over)",
            label: "Time in seconds (0 = disabled)",
            helperText: "If the customer does not respond in {{seconds}}s, AI takes over the service (purple output)"
          }
        }
      },
      moments: {
        title: "Real-time panel",
        subtitle: "Live services grouped by agent",
        pending: "Pending",
        attendances: "Attendances: ",
        noQueue: "No queue",
        accessTicket: "Access ticket",
        refresh: "Refresh",
        empty: "No active services at the moment.",
        noTickets: "No active services",
        ticketSingular: "service",
        ticketsPlural: "services",
        unread: "unread",
        kpis: {
          online: "Online agents",
          active: "Active",
          pending: "Waiting",
          top: "Top agent",
        },
      },
      flowBuilderNodes: {
        message: "Message",
        condition: "Condition",
        image: "Image"
      },
      subscription: {
        title: "Subscription",
        form: {
          licenseLabel: "License Period",
          licenseExpiresIn: "Your license expires in {{days}} days!",
          licenseExpiresToday: "Your license expires today!",
          billingEmailLabel: "Billing email",
          subscribeButton: "Subscribe Now!"
        },
        checkout: {
          form: {
            fullName: "Full name*",
            fullNameRequired: "Full name is required",
            lastName: "Last name*",
            lastNameRequired: "Last name is required",
            address: "Address*",
            addressRequired: "Address is required",
            city: "City*",
            cityRequired: "City is required",
            state: "State*",
            stateRequired: "State is required",
            document: "Tax ID*",
            documentRequired: "Tax ID is required",
            documentInvalid: "Invalid Tax ID format",
            country: "Country*",
            countryRequired: "Country is required",
            useAddressForPayment: "Use this address for payment details",
            nameOnCard: "Name on card*",
            nameOnCardRequired: "Name on card is required",
            cardNumber: "Card number*",
            cardNumberRequired: "Card number is required",
            cardNumberInvalid: "Card number is not valid (e.g. 4111111111111)",
            expiryDate: "Expiry date*",
            expiryDateRequired: "Expiry date is required",
            expiryDateInvalid: "Expiry date is not valid",
            cvv: "CVV*",
            cvvRequired: "CVV is required",
            cvvInvalid: "CVV is invalid (e.g. 357)"
          }
        }
      },
      ticketsResponsive: {
        actions: {
          selectTicket: "Select Ticket",
          transferTicket: "Transfer Ticket",
          spyConversation: "Spy Conversation"
        },
        tabs: {
          ticket: "Ticket",
          assistance: "Assistance"
        },
        search: {
          searchInMessagesTooltip: "Check to also search in message contents (slower)"
        },
        filter: {
          all: "All",
          unreplied: "Unreplied",
          title: "Filters",
          queues: "Queues",
          tags: "Tags",
          connections: "Connections",
          status: "Status",
          users: "Users",
          showTags: "Show tags",
          hideTags: "Hide tags"
        },
        sort: {
          ascending: "Ascending",
          descending: "Descending"
        },
        dialog: {
          spyingConversation: "Spying conversation",
          loadingMessages: "Loading messages..."
        },
        status: {
          noQueue: "NO QUEUE"
        }
      },
      messagesResponsive: {
        types: {
          location: "Location",
          contact: "Contact"
        },
        actions: {
          download: "Download",
          dropFileHere: "Drop file here"
        },
        status: {
          forwarded: "Forwarded",
          deletedByContact: "🚫 This message was deleted by contact",
          deletedMessage: "🚫 _Deleted message_",
          deletedByMe: "🚫 This message was deleted",
          edited: "Edited"
        },
        reactions: {
          youReacted: "You reacted...",
          contactReacted: " reacted... "
        },
        timestamp: {
          today: "TODAY"
        },
        placeholder: {
          sayHello: "Say hello to your new contact!"
        },
        ads: {
          adClick: "Ad Click",
          defaultUserMessage: "Hello! I'm interested and would like more information, please."
        },
        warnings: {
          facebookPolicy: "You have 24 hours to respond after receiving a message, according to Facebook's policies."
        },
        translation: {
          translatedFrom: "Translated from",
          showOriginal: "Show original",
          showTranslation: "Show translation",
          autoTranslated: "Auto-translated message sent",
        },
        transcription: {
          transcribe: "Transcribe audio",
          transcribing: "Transcribing...",
          showOriginal: "Show original",
          showTranslation: "Show translation",
          language: "Language",
        }
      },
      messageInputResponsive: {
        type: {
          document: "Document",
          buttons: "Buttons"
        },
        tooltip: {
          toggleSignature: "Enable/Disable Signature",
          toggleComments: "Enable/Disable Comments"
        },
        privateMessage: {
          suffix: "Private Message"
        }
      },
      tagsResponsive: {
        validation: {
          tooShort: "Tag too short!"
        },
        placeholder: "Tags"
      },
      showTicketOpenModal: {
        buttons: {
          close: "Close"
        }
      },
      reactions: {
        successMessage: "Reaction sent successfully"
      },
      vcardPreview: {
        chatButton: "Chat"
      },
      locationPreview: {
        viewButton: "View"
      },
      contactNotes: {
        addedSuccess: "Note added successfully!",
        deletedSuccess: "Note deleted successfully!",
        deleteTitle: "Delete Record",
        deleteConfirmation: "Do you really want to delete this record?",
        cancelButton: "Cancel",
        saveButton: "Save"
      },
      validationResponsive: {
        ratingRequired: "Rating required"
      }
    }
  }
};

export { messages };
